/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
export const changelogData = [
    {
        version: "1.19.4",
        date: "2026-09-21",
        changes: {
            ru: [
                "Турбо-оптимизация распыления: кратно выросла скорость и стабильность отрисовки при быстрых движениях баллоном. Добавлены пакетная обработка мазков и адаптивная интерполяция — теперь круги и теги ложатся ровно и без лагов.",
                "Плавная развязка событий мыши/сенсора: очередь событий развязана с кадрами рендеринга (60–120 FPS), устранены просадки и микрофризы."
            ],
            en: [
                "Turbo spray performance: drastically boosted rendering speed and stability during rapid strokes. Added batched path processing and adaptive interpolation — quick circles and tags now flow seamlessly without lag.",
                "Smooth event decoupling: touch and pointer events are decoupled into render frames (60–120 FPS), eliminating frame drops and stutter."
            ],
            es: [
                "Rendimiento de pulverización turbo: velocidad y estabilidad mejoradas notablemente en trazos rápidos. Procesamiento por lotes e interpolación adaptativa para trazos fluidos.",
                "Desacoplamiento fluido de eventos táctiles y puntero a 60–120 FPS sin microtirones."
            ],
            pt: [
                "Desempenho de spray turbo: velocidade e estabilidade amplamente aprimoradas em traços rápidos. Processamento em lote e interpolação adaptativa para traços suaves e sem travamentos.",
                "Desacoplamento de eventos de toque e ponteiro para 60–120 FPS sem microtravamentos."
            ],
            de: [
                "Turbo-Sprühleistung: Deutlich schnellere und stabilere Wiedergabe bei rasanten Zügen. Stapelverarbeitung und adaptive Interpolation für flüssige Kreis- und Tag-Linien ohne Ruckeln.",
                "Flüssige Entkopplung von Maus- und Touch-Ereignissen auf 60–120 FPS ohne Mikroruckler."
            ],
            fr: [
                "Performances de pulvérisation turbo : vitesse et stabilité nettement accrues lors des mouvements rapides. Traitement par lots et interpolation adaptative pour des tracés nets et fluides sans ralentissement.",
                "Découplage fluide des événements tactiles et souris (60–120 FPS), éliminant les micro-saccades."
            ],
            th: [
                "ประสิทธิภาพการพ่นสีเทอร์โบ: เพิ่มความเร็วและความเสถียรอย่างมากเมื่อลากเส้นเร็ว ประมวลผลแบบกลุ่มและการประมาณค่าแบบปรับตัวเพื่อให้เส้นกลมและแท็กลื่นไหลไม่มีสะดุด",
                "การแยกการประมวลผลสัมผัสและตัวชี้อย่างราบรื่น (60–120 FPS) ขจัดอาการหน่วง"
            ],
            ko: [
                "터보 스프레이 성능 최적화: 빠른 브러시 제스처 시 렌더링 속도와 안정성을 대폭 향상했습니다. 배치 경로 처리와 적응형 보간으로 원과 태그가 렉 없이 매끄럽게 그려집니다.",
                "터치 및 포인터 이벤트 분리로 60–120 FPS에서 끊김 없는 부드러운 드로잉 지원."
            ],
            zh: [
                "喷涂性能涡轮级优化：大幅提升快速涂画时的渲染速度与稳定性，加入批量路径处理与自适应插值，画圆和写Tag丝滑无延迟。",
                "平滑解耦触控与鼠标事件至 60–120 FPS，彻底消除卡顿与微掉帧。"
            ],
            ja: [
                "ターボスプレー最適化：素早いストローク時の描画速度と安定性を大幅に向上。バッチパス処理と適応補間により、素早い円やタグ描画がラグなく滑らかに。",
                "タッチおよびポインタイベントをレンダリングフレーム（60〜120 FPS）に分離し、カクつきを解消。"
            ],
            hi: [
                "टर्बो स्प्रे प्रदर्शन: तेज़ स्ट्रोक के दौरान रेंडरिंग गति और स्थिरता में भारी वृद्धि। बैच पाथ प्रोसेसिंग और एडेप्टिव इंटरपोलेशन के साथ सर्कल और टैग बिना किसी लैग के स्मूथ बनते हैं।",
                "टच और पॉइंटर इवेंट्स को 60-120 FPS पर स्मूथली डीकपल किया गया, माइक्रो-फ्रीज समाप्त।"
            ]
        }
    },
    {
        version: "1.19.3",
        date: "2026-07-16",
        changes: {
            ru: [
                "Завезли сочные 3D-модели кэпов и валиков прямо в менюху выбора! Теперь можешь заценить трехмерные насадки (легендарный NY Fat, Soft SWA) и валики разных размеров прямо на кнопке.",
                "Новые пресеты для плотного бомбинга: добавили жирный, средний и мелкий валики (BIG, MID, SMALL Roller), а также классический нью-йоркский кэп для правильных линий."
            ],
            en: [
                "Fresh 3D models for caps and rollers are live! Spin the new 3D caps (including the legendary NY Fat and Soft SWA) and rollers right in the selector menu.",
                "New presets for heavy bombing: added BIG, MID, and SMALL Rollers, plus the classic NY Fat Cap for clean fills and tags."
            ]
        }
    },
    {
        version: "1.19.2",
        date: "2026-06-06",
        changes: {
            ru: [
                "Добавили режим трансляции. Просто жамкай на аватар другого пользователя и смотри как он забивает стену его глазами."
            ],
            en: [
                "Broadcast mode is live! Just click on another writer's avatar to spectate and watch them tag the wall through their eyes."
            ],
            es: [
                "¡Modo transmisión activo! Solo dale click al avatar de otro grafitero para espiar y ver cómo raya el muro con sus propios ojos."
            ],
            pt: [
                "Modo transmissão no ar! Só clicar no avatar de outro grafiteiro pra espiar e ver ele pixando o muro com os próprios olhos."
            ],
            de: [
                "Broadcast-Modus ist am Start! Klick einfach auf den Avatar eines anderen Writers, um zuzuschauen, wie er die Wand durch seine Augen bombt."
            ],
            fr: [
                "Le mode diffusion est opé ! Clique sur l'avatar d'un autre graffeur pour squatter sa vue et mater comment il pose son blaze en direct."
            ],
            zh: [
                "直播模式上线！点击其他老铁的头像，直接第一人称视角围观他去刷墙。"
            ],
            ko: [
                "방송 모드 개시! 딴 라이터 아바타 대가리 찍고 걔 눈으로 벽 지르는 거 실시간 관람 ㄲ."
            ],
            ja: [
                "配信モード実装！他のライターのアバターをタップして、そいつの視点で壁をボムるのを目撃しろ。"
            ],
            th: [
                "โหมดบรอดแคสต์มาแล้ว! แค่จิ้มอวาตาร์คนอื่น ก็ส่องดูเขาพ่นกำแพงด้วยสายตาเขาได้เลย"
            ],
            hi: [
                "ब्रॉडकास्ट मोड लाइव है! बस दूसरे राइटर के अवतार पर क्लिक करो और देखो वो दीवार पर अपनी आँखों से कैसे पीस बना रहा है।"
            ]
        }
    },
    {
        version: "1.19.1",
        date: "2026-06-03",
        changes: {
            en: [
                "Your spot, your tag. Drop your nickname, location, and slap on a custom avatar — upload a photo with circular crop, grab a character from the roster, or let the wall assign you a lettermark straight from your ID."
            ],
            ru: [
                "Твой спот — твоя тема. Пропиши ник, место и поставь аватар — загрузи фотку с круговой обрезкой, выбери персонажа из ростера, или пусть стена сама назначит тебе аббревиатуру по ID."
            ],
            es: [
                "Tu spot, tu firma. Escribe tu nick, tu barrio y pon un avatar — sube una foto con recorte circular, elige un personaje del roster o deja que el muro te asigne una letra desde tu ID."
            ],
            pt: [
                "Seu spot, sua tag. Bota seu nick, sua quebrada e escolhe um avatar — sobe uma foto com corte circular, pega um personagem do roster ou deixa o muro te dar uma letra direto do seu ID."
            ],
            de: [
                "Dein Spot, dein Tag. Trag deinen Nick, deinen Kiez ein und hau dir einen Avatar drauf — lad ein Foto mit rundem Schnitt hoch, schnapp dir einen aus dem Roster oder lass die Wand dir einen Lettermark nach deiner ID vergeben."
            ],
            fr: [
                "Ton spot, ton tag. Pose ton blaze, ton quartier et mets un avatar — balance une photo avec recadrage circulaire, choisis un perso dans le roster ou laisse le mur t'assigner une lettre depuis ton ID."
            ],
            zh: [
                "你的地盘，你的签名。填上你的外号、地点，整一个头像 — 上传一张圆形裁剪的照片、从名单里挑个角色，或者让墙根据你的 ID 直接给你分配一个字母标。"
            ],
            ko: [
                "네 스팟, 네 태그. 닉네임, 동네 찍고 아바타 장착 — 원형 크롭으로 사진 올리거나, 로스터에서 캐릭 골라잡거나, 아니면 벽이 니 ID로 레터마크 자동 부여. "
            ],
            ja: [
                "あんたのスポット、あんたのタグ。ニック、場所、アバターを決めろ — 丸くトリムした写真をアップするか、ロスターからキャラを選ぶか、IDからレターマークを自動で割り当てさせろ。"
            ],
            th: [
                "สปอตของนาย แท็กของนาย ใส่ชื่อเล่น, โซน, แล้วเลือกอวาตาร์ — อัปรูปครอปวงกลม, จิ้มตัวละครจากรอสเตอร์, หรือปล่อยให้กำแพงแจกเลตเตอร์มาร์คจาก ID นาย ไม่ต้องมีหน้าก็ให้คนรู้จัก"
            ],
            hi: [
                "तेरा स्पॉट, तेरा टैग। निक, जगह डाल और अवतार लगा — सर्कुलर क्रॉप फोटो अपलोड कर, रोस्टर से कोई कैरेक्टर उठा, या वॉल तेरे ID से खुद लेटरमार्क दे देगी। चेहरा नहीं चाहिए पहचाने जाने के लिए।"
            ]
        }
    },
    {
        version: "1.19.0",
        date: "2026-05-25",
        changes: {
            en: [
                "Alpha drop: TON Connect auth is live. Connect your wallet — unlock history rollback, extra paint shades, NFT minting and more. Still early, but the foundation is solid."
            ],
            ru: [
                "Альфа-дроп: авторизация через TON Connect запущена. Коннектишь кошелёк — получаешь откат истории, дополнительные оттенки, минт кусков в NFT и ещё много чего. Пока альфа, но база готова."
            ],
            es: [
                "Alpha drop: la auth con TON Connect está live. Conectas el wallet — desbloqueas historial, más tonos, mint de piezas en NFT y más. Todavía alpha, pero la base está sólida."
            ],
            pt: [
                "Alpha drop: auth via TON Connect está no ar. Conecta a carteira — desbloqueia histórico, mais tons, mint de peças em NFT e muito mais. Ainda alpha, mas a base tá firme."
            ],
            de: [
                "Alpha-Drop: TON Connect Auth ist live. Wallet verbinden — Verlauf, mehr Farbtöne, NFT-Minting und mehr freischalten. Noch Alpha, aber die Basis steht."
            ],
            fr: [
                "Alpha drop : l'auth via TON Connect est live. Connecte ton wallet — débloques l'historique, plus de nuances, le mint en NFT et plus encore. Encore alpha, mais la base est solide."
            ],
            zh: [
                "Alpha 上线：TON Connect 授权正式开放。连接钱包 — 解锁历史回退、更多颜色、NFT 铸造等功能。还是 alpha，但基础已经稳了。"
            ],
            ko: [
                "알파 드롭: TON Connect 인증 라이브. 지갑 연결하면 — 히스토리 되돌리기, 추가 색상, NFT 민팅 등 해금. 아직 알파지만 기반은 탄탄해."
            ],
            ja: [
                "アルファ公開：TON Connect 認証がライブに。ウォレットを繋ぐと履歴復元、追加カラー、NFTミント等が解放。まだアルファだが、土台はしっかりしてる。"
            ],
            th: [
                "Alpha drop: TON Connect auth พร้อมใช้งานแล้ว เชื่อมกระเป๋าเงิน — ปลดล็อกประวัติ, สีเพิ่มเติม, มินต์ NFT และอื่นๆ ยังเป็น alpha อยู่ แต่ฐานมั่นคงแล้ว"
            ],
            hi: [
                "Alpha drop: TON Connect auth live है। वॉलेट कनेक्ट करो — हिस्ट्री rollback, एक्स्ट्रा शेड्स, NFT मिंटिंग और बहुत कुछ। अभी alpha है, पर नींव पक्की है।"
            ]
        }
    },
    {
        version: "1.18.8",
        date: "2026-05-12",
        changes: {
            en: [
                "🎙 Radio in the spot. Dropped a stream player right into the wall — pick your vibe from 8 NTS channels and let the beats ride while you throw your piece. Hip-hop, techno, ambient, raw hardcore — whatever fuels your spray hand."
            ],
            ru: [
                "🎙 Музон прямо на споте. Встроили стрим-плеер — выбирай один из 8 каналов NTS и жги под правильный саундтрек. Хип-хоп, техно, эмбиент, жёсткий хардкор — ставь что качает и кидай пис."
            ],
            es: [
                "🎙 La música ya está en el spot. Metimos un player de stream directo en el muro — elige entre 8 canales NTS y deja que el sonido te lleve mientras rallas tu pieza. Hip-hop, techno, ambient, hardcore crudo — lo que encienda tu bote."
            ],
            pt: [
                "🎙 Música no spot, direto. Jogamos um player de stream dentro do muro — escolhe entre 8 canais NTS e deixa o som rolar enquanto você joga sua peça. Hip-hop, techno, ambient, hardcore pesado — o que der gás pro seu spray."
            ],
            de: [
                "🎙 Sound direkt am Spot. Wir haben einen Stream-Player reingehauen — wähl aus 8 NTS-Kanälen und lass die Beats laufen, während du dein Piece schmeißt. Hip-Hop, Techno, Ambient, roher Hardcore — was auch immer deine Dose zum Glühen bringt."
            ],
            fr: [
                "🎙 La musique est dans le spot. On a balancé un lecteur de stream directement dans le mur — choisis parmi 8 chaînes NTS et laisse le son tourner pendant que tu poses ta pièce. Hip-hop, techno, ambient, hardcore brut — ce qui fait vibrer ta bombe."
            ],
            zh: [
                "🎙 音乐进场了。我们在墙里塞了个流媒体播放器 — 从 8 个 NTS 频道里挑你的感觉，让节拍带着你喷出你的作品。嘻哈、科技舞曲、氛围乐、硬核 — 什么点燃你的罐子就放什么。"
            ],
            ko: [
                "🎙 스팟에 음악이 왔다. 스트림 플레이어를 벽 안에 박아놨어 — NTS 채널 8개 중 골라서 피스 던지는 동안 비트 흘려. 힙합, 테크노, 앰비언트, 날 것의 하드코어 — 스프레이 손 달구는 거 틀어."
            ],
            ja: [
                "🎙 スポットに音楽が来た。ウォールにストリームプレイヤーをぶち込んだ — 8つのNTSチャンネルからバイブを選んで、ピースを描きながらビートを流せ。ヒップホップ、テクノ、アンビエント、生のハードコア — 缶を燃やすやつをかけろ。"
            ],
            th: [
                "🎙 เพลงมาถึงสปอตแล้ว ยัดสตรีมเพลเยอร์ลงในกำแพงเลย — เลือกจาก 8 ช่อง NTS แล้วปล่อยบีทวิ่งตอนที่วาดชิ้นงาน ฮิปฮอป เทคโน แอมเบียนท์ ฮาร์ดคอร์โหด — อะไรก็ตามที่ทำให้กระป๋องลุกไหม้"
            ],
            hi: [
                "🎙 स्पॉट पर म्यूज़िक आ गया। वॉल के अंदर स्ट्रीम प्लेयर ठोक दिया — 8 NTS चैनलों में से अपना वाइब चुनो और पीस बनाते हुए बीट्स बहने दो। हिप-हॉप, टेक्नो, एम्बिएंट, रॉ हार्डकोर — जो भी स्प्रे हाथ गरम करे, वो लगाओ।"
            ]
        }
    },
    {
        version: "1.18.7",
        date: "2026-05-04",
        changes: {
            en: [
                "Gesture fix: Pinch-in on trackpad now zooms out, pinch-out zooms in — natural and intuitive, just how it should be."
            ],
            ru: [
                "Инверсия жестов: сведение пальцев на тачпаде теперь отдаляет зум, размыкание — приближает. Естественно и по-человечески."
            ],
            es: [
                "Corrección de gestos: pellizcar en el trackpad ahora aleja el zoom, separar los dedos lo acerca. Natural e intuitivo, tal como debería ser."
            ],
            pt: [
                "Correção de gestos: beliscar no trackpad agora afasta o zoom, abrir os dedos aproxima. Natural e intuitivo, como deveria ser."
            ],
            de: [
                "Gesten-Fix: Zusammenkneifen auf dem Trackpad zoomt jetzt heraus, Auseinanderziehen zoomt herein — natürlich und intuitiv, so wie es sein soll."
            ],
            fr: [
                "Correction des gestes : pincer sur le trackpad éloigne maintenant le zoom, écarter les doigts l'approche — naturel et intuitif, comme il se doit."
            ],
            zh: [
                "手势修复：在触控板上捏合现在缩小，张开手指放大 — 自然直观，正如应有的那样。"
            ],
            ko: [
                "제스처 수정: 트랙패드에서 핀치인하면 줌 아웃, 핀치아웃하면 줌 인 — 자연스럽고 직관적입니다."
            ],
            ja: [
                "ジェスチャー修正：トラックパッドでのピンチインはズームアウト、ピンチアウトはズームインに — 自然で直感的な操作に。"
            ],
            th: [
                "แก้ไขท่าทาง: การบีบนิ้วบนแทร็กแพดตอนนี้ซูมออก การแยกนิ้วซูมเข้า — เป็นธรรมชาติและใช้งานง่าย"
            ],
            hi: [
                "जेस्चर फिक्स: ट्रैकपैड पर पिंच-इन अब ज़ूम आउट करता है, पिंच-आउट ज़ूम इन — प्राकृतिक और सहज।"
            ]
        }
    },
    {
        version: "1.18.6",
        date: "2026-04-19",
        changes: {
            en: [
                "Multiplayer performance upgrade: other writers' work on the spot now shows up without glitches.",
                "Fixed a double-connection bug that caused incorrect user counts.",
                "Spot user indicator now appears only at the final loading stage and is fully translated across all languages."
            ],
            ru: [
                "Апгрейд мультиплеера: работа других райтеров на споте теперь отображается без артефактов.",
                "Пофиксили баг двойного подключения, из-за которого неправильно считалось число юзеров.",
                "Индикатор юзеров на споте теперь появляется только на финальной стадии загрузки и полностью переведён."
            ],
            es: [
                "Mejora del rendimiento multijugador: el trabajo de otros escritores en el spot ahora se muestra sin fallos.",
                "Se corrigió un bug de doble conexión que causaba recuentos de usuarios incorrectos.",
                "El indicador de usuarios en el spot ahora aparece solo en la etapa final de carga y está traducido a todos los idiomas."
            ],
            pt: [
                "Melhoria de desempenho multiplayer: o trabalho de outros escritores no spot agora aparece sem falhas.",
                "Corrigido um bug de dupla conexão que causava contagens incorretas de usuários.",
                "O indicador de usuários no spot agora aparece apenas na etapa final de carregamento e está traduzido para todos os idiomas."
            ],
            de: [
                "Multiplayer-Performance-Upgrade: Die Arbeiten anderer Writer im Spot werden jetzt fehlerfrei angezeigt.",
                "Doppelverbindungs-Bug behoben, der zu falschen Benutzerzählungen führte.",
                "Der Benutzerindikator im Spot erscheint jetzt nur in der letzten Ladephase und ist in alle Sprachen übersetzt."
            ],
            fr: [
                "Amélioration des performances multijoueur : le travail des autres writers sur le spot s'affiche désormais sans erreurs.",
                "Correction d'un bug de double connexion qui causait des comptages d'utilisateurs incorrects.",
                "L'indicateur d'utilisateurs sur le spot n'apparaît plus qu'en phase finale de chargement et est traduit dans toutes les langues."
            ],
            zh: [
                "多人游戏性能升级：现在可以无故障地查看其他涂鸦者在场地上的作品。",
                "修复了导致用户数量显示错误的双重连接漏洞。",
                "场地用户指示器现在仅在加载的最后阶段显示，并已翻译成所有语言。"
            ],
            ko: [
                "멀티플레이어 성능 업그레이드: 스팟에 있는 다른 라이터의 작업이 이제 오류 없이 표시됩니다.",
                "잘못된 사용자 수를 유발하던 이중 연결 버그가 수정되었습니다.",
                "스팟 사용자 표시기는 이제 로딩의 마지막 단계에서만 표시되며 모든 언어로 번역되었습니다."
            ],
            th: [
                "อัปเกรดประสิทธิภาพมัลติเพลเยอร์: ผลงานของนักเขียนคนอื่นในสปอตแสดงผลได้โดยไม่มีข้อผิดพลาด",
                "แก้ไขบัคการเชื่อมต่อซ้ำที่ทำให้จำนวนผู้ใช้แสดงผลไม่ถูกต้อง",
                "ตัวบ่งชี้ผู้ใช้ในสปอตตอนนี้จะแสดงเฉพาะในขั้นตอนสุดท้ายของการโหลดและแปลเป็นทุกภาษาแล้ว"
            ],
            ja: [
                "マルチプレイヤーのパフォーマンスを向上。スポット内の他のライターの作業が不具合なく表示されるようになりました。",
                "ユーザー数の誤表示の原因となっていた二重接続のバグを修正しました。",
                "スポットのユーザーインジケーターは、ロードの最終段階でのみ表示され、全言語に対応しました。"
            ],
            hi: [
                "मल्टीप्लेयर प्रदर्शन को अपग्रेड किया गया, अब स्पॉट पर अन्य लेखकों के काम को बिना किसी दोष के देख सकते हैं।",
                "डबल-कनेक्शन बग को ठीक किया गया जिससे उपयोगकर्ताओं की संख्या गलत दिखाई दे रही थी।",
                "स्पॉट पर उपयोगकर्ताओं का संकेतक अब केवल लोडिंग के अंतिम चरण में दिखाया जाता है और सभी भाषाओं में अनुवादित है।"
            ]
        }
    },
    {
        version: "1.18.5",
        date: "2026-04-17",
        changes: {
            en: [
                "Major engine performance boost: painting and movement are now even smoother and more responsive.",
                "Polished loading experience: improved progress stability for a seamless transition to the wall.",
                "General UI refinements and under-the-hood optimizations for a cleaner experience."
            ],
            ru: [
                "Глобальное ускорение движка: теперь рисование и движения стали еще плавнее и отзывчивее.",
                "Тюнинг процесса загрузки: доработали стабильность прогресса, теперь всё идет плавно до самой победной точки.",
                "Мелкие правки интерфейса и устранение технических ошибок для более чистой работы."
            ],
            es: [
                "Gran aumento del rendimiento: los trazos y movimientos son ahora mucho más fluidos y reactivos.",
                "Experiencia de carga pulida: mejoras en la estabilidad del progreso para una transición perfecta.",
                "Refinamientos generales en la interfaz y correcciones menores."
            ],
            pt: [
                "Grande aumento de desempenho: traços e movimentos agora estão mais fluidos e responsivos.",
                "Experiência de carregamento aprimorada: estabilidade de progresso para uma transição suave.",
                "Refinamentos gerais na interface e correções técnicas."
            ],
            de: [
                "Starke Leistungssteigerung: Malen und Bewegungen sind jetzt noch flüssiger und reaktionsschneller.",
                "Verbessertes Ladeerlebnis: stabilere Fortschrittsanzeige für einen nahtlosen Übergang.",
                "Allgemeine Optimierungen und Fehlerbehebungen."
            ],
            fr: [
                "Boost majeur de performance : les traits et mouvements sont plus fluides et réactifs.",
                "Expérience de chargement peaufinée : stabilité du progrès pour une transition parfaite.",
                "Ajustements d'interface et corrections techniques générales."
            ],
            zh: [
                "引擎性能重大提升：绘画和移动现在更加流畅，反应更迅速。",
                "优化加载体验：提高了进度条的稳定性，实现无缝切换。",
                "常规界面优化及技术错误修复。"
            ],
            ja: [
                "エンジン性能の大幅な向上：描画と動作がよりスムーズでレスポンシブになりました。",
                "ロード体験の改善：進捗の安定性を高め、シームレスな移行を実現しました。",
                "UIの微調整および全般的なバグ修正。"
            ],
            ko: [
                "엔진 성능 대폭 향상: 페인팅과 이동이 더욱 부드럽고 빨라졌습니다.",
                "로딩 경험 개선: 진행 상태의 안정성을 높여 완벽한 전환이 가능합니다.",
                "일반 UI 개선 및 버그 수정."
            ],
            th: [
                "เพิ่มประสิทธิภาพเอนจินครั้งใหญ่: การวาดและการเคลื่อนไหวลื่นไหลยิ่งขึ้น",
                "ปรับปรุงประสบการณ์การโหลด: เพิ่มความเสถียรของแถบความคืบหน้าเพื่อการเปลี่ยนผ่านที่ราบรื่น",
                "ปรับแต่ง UI ทั่วไปและแก้ไขข้อผิดพลาดเล็กน้อย"
            ],
            hi: [
                "इंजन प्रदर्शन में बड़ा सुधार: पेंटिंग और हलचल अब और भी स्मूथ है।",
                "बेहतर लोडिंग अनुभव: प्रोग्रेस बार में सुधार किया गया है।",
                "सामान्य यूआई सुधार और बग फिक्स।"
            ]
        }
    },
    {
        version: "1.18.4",
        date: "2026-04-16",
        changes: {
            en: [
                "Mobile nav fixed: Two-finger swipe in Grab mode now actually moves you along the wall. One finger still rotates the view—finally works like it should.",
                "Cursor cleanup: spray cursor stays circular on spray presets even in Flat mode. No more shape confusion when switching modes."
            ],
            ru: [
                "Навигация в адаптиве: два пальца в режиме Grab теперь двигают камеру вдоль стены, один палец крутит обзор. Наконец-то как надо.",
                "Чистка курсоров: в пресетах баллончика курсор остаётся круглым даже в режиме Flat. Больше никакой путаницы с формой при переключении."
            ]
        }
    },
    {
        version: "1.18.3",
        date: "2026-04-15",
        changes: {
            en: [
                "Mobile polish: Stripped out redundant background layers and fixed that custom cursor overlap. Handheld vibes are now pure and smooth.",
                "Custom Cursor Logic: The spray indicators now play nice with the UI—they vanish when you hit the menus and show up only when you're on the wall."
            ],
            ru: [
                "Мобильный тюнинг: выпилили лишние слои подложки и пофиксили наслоение курсора на кнопки. Теперь в портативе всё чисто, без лишнего мусора.",
                "Умные курсоры: индикаторы распыла теперь дружат с интерфейсом — они прячутся, когда ты в менюшках, и светятся только там, где реально рисуешь."
            ]
        }
    },
    {
        version: "1.18.2",
        date: "2026-04-12",
        changes: {
            en: [
                "Under the hood tuning: Stripped down the heavy UI components into sleek modular sheets. The mobile spot loads crazy fast now without the extra baggage.",
                "Loader locals: The loading matrix now speaks your language. Hints during the startup sequence are fully translated so nobody gets left in the dark."
            ],
            ru: [
                "Тюнинг под капотом: распилили тяжелые куски интерфейса на модульные запчасти. Теперь мобильный спот грузится в разы быстрее, без лишнего мусора.",
                "Локализация лоадера: матрица загрузки теперь в курсе, откуда ты. Все подсказки перевели на твой язык, так что больше никаких непоняток на старте."
            ],
            es: [
                "Afinación bajo el capó: Cortamos los componentes pesados de la UI en sábanas modulares. El spot móvil carga rapidísimo sin basura extra.",
                "Locales del cargador: La matriz de carga ahora habla tu argot. Las pistas de inicio están en tu idioma para que todos entiendan el flow."
            ],
            pt: [
                "Ajuste fino no motor: Cortamos o peso da UI transformando em módulos. O pico móvel carrega bolado de rápido agora, sem peso extra.",
                "Sotaque do carregamento: A matriz de carregamento agora fala sua língua. As dicas iniciais tão todas traduzidas pra ninguém ficar moscando."
            ],
            de: [
                "Tuning unter der Haube: Fette UI-Komponenten in schlanke Module zerlegt. Der mobile Spot lädt jetzt krass schnell ohne zusätzlichen Ballast.",
                "Lokalisierung beim Laden: Die Matrix spricht jetzt deinen Slang. Alle Tipps beim Starten sind übersetzt, keiner tappt im Dunkeln."
            ],
            fr: [
                "Tuning sous le capot : On a découpé les gros morceaux d'UI en modules. Le spot mobile charge à toute vitesse sans bagage lourd.",
                "Locals du loader : La matrice de chargement parle ton argot. Les astuces du début sont traduites pour que personne ne reste sur le trottoir."
            ],
            th: [
                "แต่งซิ่งใต้ฝากระโปรง: รื้อ UI หนักๆ ออก แล้วเปลี่ยนเป็นชิ้นส่วนเบาๆ ตอนนี้สปอตบนมือถือโหลดเร็วปรื๊ด ไม่มีขยะถ่วงเครื่อง",
                "โหลดเดอร์พูดภาษาคุณ: เมทริกซ์ตอนโหลดเข้าใจภาษาคุณแล้วนะ คำใบ้ตอนเปิดแอพแปลครบถ้วน ไม่ต้องเดาให้งง"
            ],
            ko: [
                "후드 아래 튜닝: 무거운 UI를 가볍고 모듈화된 파트로 분해했습니다. 모바일 스팟이 이제 불필요한 짐 없이 미친 듯이 빠르게 로드됩니다.",
                "로더 현지화: 로딩 매트릭스가 이제 당신의 언어를 구사합니다. 시작할 때 나오는 힌트들이 모두 번역되어 누구 하나 헷갈리지 않습니다."
            ],
            zh: [
                "底层引擎改造：把臃肿的 UI 拆成了模块化的轻量面板。移动端据点现在加载快到飞起，彻底甩掉多余包袱。",
                "加载页本地化：加载矩阵现在懂你的黑话了。启动时所有提示语全部翻译到位，再也不用瞎眼看鸡肠文。"
            ],
            ja: [
                "エンジンのチューニング：重いUIをスマートなモジュールに分解しました。余計な荷物がないのでモバイルスポットが爆速でロードされます。",
                "ローダーの現地化：ローディング・マトリックスがあなたの言語を話すようになりました。起動画面でのヒントもバッチリ翻訳されて迷うことはありません。"
            ],
            hi: [
                "हुड के नीचे ट्यूनिंग: भारी UI को मॉड्यूलर शीट्स में तोड़ दिया। अब मोबाइल स्पॉट बिना किसी फालतू वजन के बहुत तेज़ी से लोड होता है।",
                "लोडर लोकल्स: लोडिंग मैट्रिक्स अब आपकी भाषा बोलती है। शुरुआत के संकेत अनुवादित कर दिए गए हैं ताकि कोई भ्रमित न रहे।"
            ]
        },
    },
    {
        version: "1.8.1",
        date: "2026-04-11",
        changes: {
            en: [
                "Roller Sync: Achieved pixel-perfect synchronization between the dynamic roller cursor and the paint stroke footprint across all presets.",
                "Perspective Scaling: Implemented dynamic perspective-aware scaling for the roller cursor to match 4K wall texture footprint.",
                "UI Restoration: Restored mobile view counter and calibration trigger for improved accessibility.",
            ],
            ru: [
                "Синхронизация валика: достигнута идеальная синхронизация динамического курсора валика с пятном краски для всех пресетов.",
                "Перспективное масштабирование: внедрено динамическое масштабирование курсора валика с учетом перспективы для соответствия 4K текстуре стены.",
                "Восстановление UI: возвращен счетчик просмотров и триггер калибровки в мобильное меню для лучшей доступности.",
            ],
        },
    },
    {
        version: "1.8.0",
        date: "2026-04-10",
        changes: {
            en: [
                "🔥 MAJOR 1.8.0 RELEASE!",
                "Massive 3D Spot: The high-fidelity 3D wall is now the main playground, accessible from anywhere in the app.",
                "Dynamic Atmosphere: Real-time Time of Day lighting system with high-performance global HDRI environments.",
                "Visual Overhaul: Entirely revamped premium UI featuring deep glassmorphism and hyper-smooth micro-animations.",
                "Precision Spraying: Integrated a new circular cursor that dynamically reflects your tool's current spray radius.",
                "Gesture Control: Seamlessly adjust spray radius using mouse wheel or trackpad gestures while painting.",
            ],
            ru: [
                "🔥 СУПЕР МАЖОРНЫЙ РЕЛИЗ 1.8.0!",
                "Глобальный 3D Спот: Огромная 3D стена теперь доступна из любой точки приложения — это новый стандарт погружения.",
                "Живая Атмосфера: Динамическая смена времени суток с реалистичным глобальным освещением (HDRI).",
                "Эволюция UI: Полностью обновленный премиальный интерфейс с эффектами матового стекла и ультра-плавными анимациями.",
                "Точность Распыла: Новый круговой курсор, который визуально отражает реальный радиус вашего баллона в реальном времени.",
                "Жестовое Управление: Меняйте радиус распыления на лету с помощью колесика мыши или тачпада прямо во время рисования.",
            ],
            es: [
                "🔥 LANZAMIENTO MAYOR 1.8.0!",
                "Spot 3D Masivo: El muro 3D de alta fidelidad ahora es el campo de juego principal, accesible desde cualquier lugar.",
                "Atmósfera Dinámica: Sistema de iluminación de hora del día en tiempo real con entornos HDRI globales.",
                "Renovación Visual: Interfaz premium completamente renovada con glassmorphism profundo y micro-animaciones fluidas.",
                "Pulverización de Precisión: Nuevo cursor circular que refleja dinámicamente el radio de pulverización actual.",
            ],
            pt: [
                "🔥 LANÇAMENTO MARCANTE 1.8.0!",
                "Mural 3D Massivo: A parede 3D de alta fidelidade agora é o palco principal, acessível de qualquer lugar.",
                "Atmosfera Dinâmica: Sistema de iluminação de hora do dia em tempo real com HDRI global de alta performance.",
                "Interface Premium: UI totalmente renovada com efeitos de vidro fosco e micro-animações ultra-suaves.",
            ],
            de: [
                "🔥 MAJOR RELEASE 1.8.0!",
                "Massiver 3D-Spot: Das High-Fidelity-3D-Wand-System ist jetzt der Hauptspielplatz, überall zugänglich.",
                "Dynamische Atmosphäre: Echtzeit-Tageszeit-Beleuchtung mit globalen HDRI-Umgebungen.",
                "Visual Overhaul: Komplett überarbeitetes Premium-UI mit tiefem Glassmorphismus und flüssigen Animationen.",
            ],
            fr: [
                "🔥 SORTIE MAJEURE 1.8.0 !",
                "Spot 3D Massif : Le mur 3D haute fidélité est désormais le terrain de jeu principal, accessible partout.",
                "Atmosphère Dynamique : Éclairage en temps réel selon l'heure du jour avec environnements HDRI globaux.",
                "Refonte Visuelle : Interface premium entièrement repensée avec glassmorphisme profond et animations fluides.",
            ],
            th: [
                "🔥 เวอร์ชันหลัก 1.8.0 มาแล้ว!",
                "กำแพง 3D สุดอลังการ: กำแพง 3D ความละเอียดสูงกลายเป็นพื้นที่หลัก เข้าถึงได้จากทุกที่ในแอป",
                "บรรยากาศสมจริง: ระบบแสงสีตามช่วงเวลาแบบเรียลไทม์พร้อมสภาพแวดล้อม HDRI ระดับโลก",
                "UI ระดับพรีเมียม: ปรับปรุงอินเทอร์เฟซใหม่ทั้งหมดด้วยดีไซน์ Glassmorphism และแอนิเมชันที่ลื่นไหลสุดๆ",
            ],
            ko: [
                "🔥 메이저 1.8.0 릴리즈!",
                "대규모 3D 스팟: 고해상도 3D 벽이 이제 메인 플레이그라운드가 되었으며 어디서나 접근 가능합니다.",
                "다이내믹 대기: 고성능 글로벌 HDRI를 이용한 실시간 시간대별 조명 시스템 도입.",
                "UI 대개혁: 깊이 있는 글래스모피즘과 초매끄러운 마이크로 애니메이션이 적용된 프리미엄 UI.",
            ],
            zh: [
                "🔥 1.8.0 重大版本更新！",
                "史诗级 3D 地盘：高精度 3D 墙面现已成为核心玩法，随处可见，随时开喷。",
                "动态光影：采用高性能全局 HDRI 的实时昼夜照明系统。",
                "视觉革新：全新设计的极致 UI，融合深度毛玻璃特效与超顺滑交互动画。",
                "精准控制：新增动态圆形光标，实时反映工具喷涂半径，支持滚轮与触控板手势调节。",
            ],
            ja: [
                "🔥 メジャーアップデート 1.8.0 到来！",
                "大規模 3D スポット：高精細 3D ウォールがメイン機能となり、アプリのどこからでもアクセス可能に。",
                "ダイナミックな雰囲気：高性能グローバル HDRI によるリアルタイムな時間経過照明システム。",
                "UIの全面刷新：深いグラスモーフィズムと超スムーズなアニメーションを採用したプレミアムなデザイン。",
            ],
            hi: [
                "🔥 मेजर 1.8.0 रिलीज़!",
                "विशाल 3D स्पॉट: हाई-फिडेलिटी 3D दीवार अब मुख्य खेल का मैदान है, जो कहीं से भी उपलब्ध है।",
                "गतिशील वातावरण: वास्तविक समय दिन के समय प्रकाश व्यवस्था, ग्लोबल HDRI के साथ।",
                "विजुअल ओवरहाल: उत्कृष्ट ग्लासमोर्फिज्म और सुपर स्मूथ एनिमेशन के साथ नया प्रीमियम UI।",
            ],
        },
    },
    {
        version: "1.17.3",
        date: "2026-03-24",
        changes: {
            en: [
                "3D Scene Isolation: Restricted drawing to the wall surface only. Ground and pavement are now protected from accidental painting.",
                "Improved 3D hit detection: More precise spray application on textured brick and concrete surfaces.",
            ],
            ru: [
                "Изоляция 3D-сцены: Ограничили зону рисования только поверхностью стены. Теперь тротуары и земля защищены от случайных штрихов.",
                "Улучшенная коллизия: Более точное нанесение краски на текстурированные кирпичные и бетонные поверхности.",
            ],
            es: [
                "Aislamiento de escena 3D: Se restringió el dibujo solo a la superficie de la pared. El suelo y el pavimento ahora están protegidos de la pintura accidental.",
            ],
            pt: [
                "Isolamento de cena 3D: Desenho restrito apenas à superfície da parede. O chão e o pavimento agora estão protegidos de pintura acidental.",
            ],
        },
    },
    {
        version: "1.17.2",
        date: "2026-03-23",
        changes: {
            en: [
                "3D Tool Logic: Fixed a bug where only the spray can worked in 3D. Now the roller and small cap (tag cap) algorithms engage properly when selected.",
                "Unified behavior: Switching between tools in 3D now matches the 2D experience, including specific physical properties for each instrument.",
            ],
            ru: [
                "Логика 3D-инструментов: исправлен баг, из-за которого в 3D работал только баллончик. Теперь валик и маленькие кэпы (тэг) работают корректно при выборе.",
                "Единое поведение: переключение инструментов в 3D теперь полностью соответствует 2D-опыту, включая физику каждого инструмента.",
            ],
            es: [
                "Lógica de herramientas 3D: se corrigió un error por el cual solo funcionaba el aerosol en 3D. Ahora el rodillo y el tapón pequeño funcionan correctamente.",
            ],
            pt: [
                "Lógica de ferramentas 3D: corrigido um erro onde apenas o spray funcionava em 3D. Agora o rolo e a tampa pequena funcionam corretamente.",
            ],
            de: [
                "3D-Werkzeuglogik: Fehler behoben, bei dem nur die Sprühdose in 3D funktionierte. Jetzt funktionieren Roller und kleine Kappen korrekt.",
            ],
            fr: [
                "Logique des outils 3D : correction d'un bug où seule la bombe fonctionnait en 3D. Maintenant, le rouleau et les petits caps fonctionnent correctement.",
            ],
            th: [
                "ตรรกะเครื่องมือ 3D: แก้ไขบั๊กที่ทำให้ใช้ได้แค่สีสเปรย์ใน 3D ตอนนี้ลูกกลิ้งและแคปเล็กใช้งานได้ปกติแล้ว",
            ],
            ko: [
                "3D 도구 로직: 3D에서 스프레이만 작동하던 버그를 수정했습니다. 이제 롤러와 작은 캡이 정상적으로 작동합니다.",
            ],
            zh: [
                "3D工具逻辑：修复了3D中只有喷漆罐有效的错误。现在滚筒和细盖可以正常工作。",
            ],
            ja: [
                "3Dツールロジック：3Dでスプレー缶しか機能しなかったバグを修正しました。ローラーや小さなキャップが正しく動作するようになりました。",
            ],
            hi: [
                "3D टूल लॉजिक: 3D में केवल स्प्रे कैन काम करने वाले बग को ठीक किया गया। अब रोलर और छोटे कैप सही तरह से काम करते हैं।",
            ],
        },
    },
    {
        version: "1.17.1",
        date: "2026-03-22",
        changes: {
            en: [
                "3D Wall Hotfix: SSR black screen eliminated — the wall now loads properly on Vercel production, not just in dev preview.",
                "Model compression: wall_opt.glb is 12x lighter than before (1.5 MB vs 19 MB) using meshopt — no decoder needed, zero setup overhead.",
                "Loading spinner: no more silent black screen while the model fetches. A clean animated loader shows up until the wall is ready to paint.",
            ],
            ru: [
                "Хотфикс 3D-стены: убрали чёрный экран при SSR — теперь стена нормально грузится на Vercel и на проде, а не только на девелоп-превью.",
                "Сжатие модели: wall_opt.glb в 12 раз легче оригинала (1.5 MB против 19 MB) через meshopt — никакого Draco, никаких лишних decoder-файлов.",
                "Спиннер загрузки: больше нет немого чёрного экрана пока модель качается. Показывается анимированный лоадер до тех пор, пока стена не готова к покраске.",
            ],
            es: [
                "Hotfix 3D Wall: pantalla negra SSR eliminada — el muro ahora carga correctamente en producción Vercel, no solo en vista previa dev.",
                "Compresión del modelo: wall_opt.glb pesa 12 veces menos (1.5 MB vs 19 MB) con meshopt — sin decoder extra, sin configuración.",
                "Spinner de carga: ya no más pantalla negra silenciosa mientras carga el modelo. Aparece un loader animado hasta que el muro está listo.",
            ],
            pt: [
                "Hotfix 3D Wall: tela preta SSR eliminada — o muro agora carrega corretamente na produção Vercel, não apenas no preview dev.",
                "Compressão do modelo: wall_opt.glb pesa 12x menos (1.5 MB vs 19 MB) con meshopt — sem decoder, sem configuração extra.",
                "Spinner de carregamento: sem mais tela preta silenciosa enquanto o modelo baixa. Um loader animado aparece até o muro estar pronto.",
            ],
            de: [
                "3D-Wand Hotfix: SSR-Schwarzbild behoben — die Wand lädt jetzt korrekt auf Vercel Produktion, nicht nur im Dev-Preview.",
                "Modellkomprimierung: wall_opt.glb ist 12x leichter (1.5 MB vs 19 MB) mit meshopt — kein Decoder, kein zusätzlicher Setup.",
                "Lade-Spinner: kein stilles Schwarzbild mehr während das Modell lädt. Ein animierter Lader erscheint bis die Wand bereit zum Malen ist.",
            ],
            fr: [
                "Hotfix 3D Wall: écran noir SSR éliminé — le mur se charge maintenant correctement en production Vercel, pas seulement en aperçu dev.",
                "Compression du modèle: wall_opt.glb est 12x plus léger (1.5 MB vs 19 MB) avec meshopt — pas de décodeur, pas de configuration supplémentaire.",
                "Spinner de chargement: plus d'écran noir silencieux pendant le téléchargement du modèle. Un loader animé s'affiche jusqu'à ce que le mur soit prêt.",
            ],
            th: [
                "แก้ไขด่วน 3D Wall: แก้ปัญหาหน้าจอดำ SSR — กำแพงโหลดได้ถูกต้องบน Vercel production ไม่ใช่แค่ dev preview",
                "บีบอัดโมเดล: wall_opt.glb เบากว่าเดิม 12 เท่า (1.5 MB vs 19 MB) ด้วย meshopt — ไม่ต้องการ decoder ไม่มีค่าใช้จ่ายเพิ่ม",
                "สปินเนอร์โหลด: ไม่มีหน้าจอดำเงียบขณะโหลดโมเดลอีกต่อไป แสดง loader เคลื่อนไหวจนกว่ากำแพงจะพร้อม",
            ],
            ko: [
                "3D 벽 핫픽스: SSR 블랙 스크린 제거 — 이제 개발 프리뷰뿐만 아니라 Vercel 프로덕션에서도 정상적으로 로드됩니다.",
                "모델 압축: wall_opt.glb가 meshopt으로 12배 가벼워짐 (1.5 MB vs 19 MB) — 디코더 불필요, 추가 설정 없음.",
                "로딩 스피너: 모델 로딩 중 침묵의 블랙 스크린이 사라졌습니다. 벽이 준비될 때까지 애니메이션 로더가 표시됩니다.",
            ],
            zh: [
                "3D墙热修复：消除了SSR黑屏问题——墙现在可以在Vercel生产环境正确加载，不只是开发预览。",
                "模型压缩：wall_opt.glb使用meshopt压缩后轻了12倍（1.5 MB vs 19 MB）——无需解码器，零配置开销。",
                "加载动画：模型加载时不再有无声的黑屏。显示动画加载器直到墙准备好绘制。",
            ],
            ja: [
                "3Dウォールホットフィックス：SSRブラックスクリーンを修正 — devプレビューだけでなく、Vercelプロダクションでも正常に読み込まれるようになりました。",
                "モデル圧縮：wall_opt.glbがmeshoptで12倍軽量化（1.5 MB vs 19 MB）— デコーダー不要、追加設定なし。",
                "ローディングスピナー：モデル読み込み中の無音ブラックスクリーンがなくなりました。壁が準備できるまでアニメーションローダーが表示されます。",
            ],
            hi: [
                "3D वॉल हॉटफिक्स: SSR ब्लैक स्क्रीन समाप्त — अब दीवार Vercel प्रोडक्शन पर सही तरह लोड होती है, केवल dev preview में नहीं।",
                "मॉडल कम्प्रेशन: wall_opt.glb meshopt से 12 गुना हल्का (1.5 MB vs 19 MB) — कोई decoder नहीं, कोई अतिरिक्त setup नहीं।",
                "लोडिंग स्पिनर: मॉडल लोड होते समय अब चुप्पी वाली काली स्क्रीन नहीं। दीवार तैयार होने तक एनिमेटेड लोडर दिखता है।",
            ],
        },
    },
    {
        version: "1.17.0",
        date: "2026-03-22",
        changes: {
            en: [
                "3D Spot Unlocked: The whole wall just went three-dimensional. Now you can bomb a fully textured brick wall straight from the block — real concrete, real vibes.",
                "Zoom presets 1/2/3: Tap 1 for up-close tags (100%), tap 2 for the mid stance (58%), tap 3 to scope the whole piece from across the yard (25%). Same hotkeys as 2D for that unified flow.",
                "Scroll zoom: Mouse wheel and trackpad pinch still work freely. The zoom bar and percentage button always stay synced with where you actually are.",
                "3D Pan mode: Hold Space to switch your cursor to the grab hand — just like in 2D. Navigate the wall without breaking your stroke.",
                "Cloud save (Ctrl+S): Works in both 2D and 3D modes now. Hit Ctrl+S and your piece flies straight to the server vault. No more lost work.",
                "Hard reset (R): Confirmed wipe now destroys ALL your layers on the wall — local canvas and the cloud chunks — leaving nothing but bare wall for the next session.",
                "Smooth clear: Fixed a stale-reference bug where clearing the wall still showed old paint. All three canvas layers (active, base, composite) now get wiped for real.",
            ],
            ru: [
                "3D-Спот открыт: стена ушла в три измерения. Теперь бомбишь полноценную кирпичную стену с текстурами — настоящий бетон, настоящий вайб.",
                "Зум-пресеты 1/2/3: жми 1 — тэг вплотную (100%), жми 2 — средняя дистанция (58%), жми 3 — смотришь на весь кусок с расстояния (25%). Те же хоткеи, что и в 2D — единый флоу.",
                "Скролл-зум: колёсо мыши и щипок трекпада работают как прежде. Ползунок и кнопка процента всегда синхронны с реальной позицией камеры.",
                "3D Grab-режим: зажимаешь Пробел — курсор превращается в лапку, как в 2D. Двигаешься вдоль стены, не теряя штрих.",
                "Сохранение в облако (Ctrl+S): работает теперь в обоих режимах — 2D и 3D. Нажал — кусок улетел на сервер. Больше никаких потерь.",
                "Жёсткий сброс (R): подтверждённая очистка теперь сносит ВСЕ твои слои — и локально, и в облаке. Стена голая, как в первый день.",
                "Фикс очистки: поправили баг замыкания, из-за которого после сброса старая краска оставалась на стене. Теперь все три слоя холста сметаются полностью.",
            ],
            es: [
                "3D Spot desbloqueado: el muro acaba de pasar a tres dimensiones. Ahora bombeas una pared de ladrillos con textura real — cemento auténtico, vibra auténtica.",
                "Presets de zoom 1/2/3: toca 1 para tags al ras (100%), 2 para la postura media (58%), 3 para ver toda la pieza desde lejos (25%). Mismos atajos que en 2D, flujo unificado.",
                "Zoom con scroll: la rueda del ratón y el gesto de pellizco en el trackpad siguen funcionando libremente. La barra y el botón de porcentaje se sincronizan siempre.",
                "Modo Pan 3D: mantén Espacio para cambiar el cursor al modo agarre — igual que en 2D. Navega por el muro sin perder el trazo.",
                "Guardado en nube (Ctrl+S): ahora funciona en modo 2D y 3D. Pulsa Ctrl+S y tu pieza va directa al servidor. Sin más pérdidas.",
                "Reset total (R): el borrado confirmado elimina TODAS tus capas — lienzo local y fragmentos en la nube. Solo queda la pared desnuda.",
                "Fix de limpieza: corregido el bug de referencia obsoleta que dejaba pintura vieja al limpiar. Las tres capas del lienzo se borran de verdad.",
            ],
            pt: [
                "3D Spot liberado: o muro foi para o 3D. Agora você bomba uma parede de tijolos com textura de verdade — concreto real, vibe real.",
                "Presets de zoom 1/2/3: toca 1 para tags perto (100%), 2 para distância média (58%), 3 para ver toda a peça de longe (25%). Mesmos atalhos do 2D para um flow unificado.",
                "Zoom por scroll: roda do mouse e gesto de pinça continuam funcionando normalmente. A barra e o botão de porcentagem ficam sempre sincronizados.",
                "Modo Pan 3D: segura Espaço e o cursor vira a mão de agarre — igualzinho ao 2D. Navega pelo muro sem perder o traço.",
                "Salvar na nuvem (Ctrl+S): agora funciona em 2D e 3D. Pressiona Ctrl+S e sua peça vai direto pro servidor. Chega de perder trabalho.",
                "Reset total (R): o apagamento confirmado destrói TODAS as suas camadas — locais e na nuvem. Só o muro pelado pra próxima sessão.",
                "Correção de limpeza: bug de referência obsoleta corrigido. As três camadas do canvas são apagadas de verdade.",
            ],
            de: [
                "3D-Spot freigeschalten: Die Wand ist jetzt dreidimensional. Bomb eine vollständig texturierte Backsteinwand — echter Beton, echte Vibes.",
                "Zoom-Presets 1/2/3: Drücke 1 für nahes Tagging (100%), 2 für die mittlere Distanz (58%), 3 um den vollen Überblick zu bekommen (25%). Gleiche Hotkeys wie in 2D — einheitlicher Flow.",
                "Scroll-Zoom: Mausrad und Trackpad-Geste funktionieren wie gewohnt. Die Zoom-Anzeige bleibt immer synchron.",
                "3D Pan-Modus: Leertaste halten wechselt den Cursor zur Grabhand — genau wie in 2D. Navigiere an der Wand entlang ohne den Strich zu verlieren.",
                "Cloud-Save (Ctrl+S): Funktioniert jetzt in 2D und 3D. Drücke Ctrl+S und dein Piece verschwindet direkt in den Server-Tresor.",
                "Hard-Reset (R): Bestätigtes Löschen vernichtet ALLE deine Ebenen — lokal und in der Cloud. Nur die nackte Wand bleibt.",
                "Fix beim Löschen: Bug behoben, der alte Farbe auf der Wand hinterließ. Alle drei Canvas-Ebenen werden jetzt wirklich geleert.",
            ],
            fr: [
                "Spot 3D débloqué : le mur passe en trois dimensions. Tu bombas maintenant une vraie brique texturée — béton authentique, vibe authentique.",
                "Presets de zoom 1/2/3 : tape 1 pour les tags de près (100%), 2 pour la distance moyenne (58%), 3 pour voir toute la pièce de loin (25%). Mêmes touches qu'en 2D - flow unifié.",
                "Zoom par défilement : la molette et le pincement sur trackpad fonctionnent toujours. La barre et le bouton de pourcentage restent synchronisés.",
                "Mode Pan 3D : maintiens Espace pour passer en mode Agrippe — comme en 2D. Navigue le long du mur sans perdre ton trait.",
                "Sauvegarde cloud (Ctrl+S) : fonctionne maintenant en 2D et 3D. Appuie sur Ctrl+S et ta pièce file directement sur le serveur.",
                "Reset total (R) : l'effacement confirmé détruit TOUTES tes couches — localement et dans le cloud. Seulement le mur brut pour la prochaine session.",
                "Fix du nettoyage : bug de référence obsolète corrigé. Les trois couches canvas sont maintenant vraiment effacées.",
            ],
            th: [
                "ปลดล็อกสปอต 3D: กำแพงกลายเป็นสามมิติแล้ว ตอนนี้คุณพ่นบนกำแพงอิฐที่มีเท็กซ์เจอร์จริงๆ คอนกรีตแท้ ความรู้สึกแท้",
                "พรีเซ็ตซูม 1/2/3: กด 1 สำหรับมุมใกล้ (100%), กด 2 สำหรับระยะกลาง (58%), กด 3 สำหรับดูภาพรวมทั้งหมด (25%) ปุ่มลัดเดียวกับ 2D",
                "ซูมด้วยสโครล: ล้อเมาส์และการหยิกบนแทร็กแพดยังทำงานได้ตามปกติ แถบซูมและปุ่มเปอร์เซ็นต์จะซิงค์กับตำแหน่งกล้องเสมอ",
                "โหมด Pan 3D: กด Space ค้างไว้เพื่อเปลี่ยนเคอร์เซอร์เป็นมือจับ เหมือนใน 2D เลย เลื่อนไปตามกำแพงโดยไม่เสียเส้น",
                "บันทึกคลาวด์ (Ctrl+S): ใช้ได้ทั้งในโหมด 2D และ 3D กด Ctrl+S แล้วผลงานของคุณจะบินตรงไปที่เซิร์ฟเวอร์ ไม่สูญหายอีกแล้ว",
                "รีเซ็ตถาวร (R): การยืนยันลบจะทำลายทุกเลเยอร์ของคุณ ทั้งโลคัลและในคลาวด์ เหลือแค่กำแพงเปล่าสำหรับเซสชันหน้า",
                "แก้บั๊กล้างจอ: แก้ไขบั๊กอ้างอิงเก่าที่ทำให้สีเก่าค้างอยู่หลังล้าง ตอนนี้สามเลเยอร์ถูกล้างจริง",
            ],
            ko: [
                "3D 스팟 오픈: 벽이 3차원으로 진화했습니다. 이제 완전한 질감의 벽돌 벽에 태깅할 수 있습니다 — 진짜 콘크리트, 진짜 바이브.",
                "줌 프리셋 1/2/3: 1번은 클로즈업 태그 (100%), 2번은 중간 거리 (58%), 3번은 전체 피스 감상 (25%). 2D와 같은 단축키로 통일된 플로우.",
                "스크롤 줌: 마우스 휠과 트랙패드 핀치 제스처는 여전히 자유롭게 작동합니다. 줌 바와 퍼센트 버튼은 항상 실제 카메라 위치와 동기화됩니다.",
                "3D 팬 모드: 스페이스를 누르면 커서가 그랩 핸드로 변합니다 — 2D와 동일합니다. 스트로크를 잃지 않고 벽을 이동합니다.",
                "클라우드 저장 (Ctrl+S): 이제 2D와 3D 모두 작동합니다. Ctrl+S를 누르면 피스가 서버로 직접 전송됩니다.",
                "하드 리셋 (R): 확인된 지우기는 모든 레이어를 삭제합니다 — 로컬과 클라우드 모두. 다음 세션을 위한 빈 벽만 남습니다.",
                "지우기 수정: 오래된 참조 버그로 인해 지운 후에도 이전 페인트가 남는 문제를 해결했습니다.",
            ],
            zh: [
                "3D 地盘解锁：整面墙正式进入三维空间。现在你可以在全纹理砖砌外墙上撒野——真实的混凝土，真实的街头气息。",
                "缩放预设 1/2/3：按 1 近距离打标（100%），按 2 中距离站位（58%），按 3 退后看整幅作品（25%）。和 2D 一样的快捷键，统一的流畅体验。",
                "滚轮缩放：鼠标滚轮和触控板捏合手势仍然自由工作。缩放条和百分比按钮始终与相机实际位置同步。",
                "3D 平移模式：按住空格键将光标切换为抓手——和 2D 一模一样。沿着墙移动而不中断笔触。",
                "云端保存（Ctrl+S）：现在 2D 和 3D 均可使用。按下 Ctrl+S，你的涂鸦直飞服务器。再也不会丢失作品。",
                "硬重置（R）：确认清除现在会销毁你所有图层——本地和云端全部清干净。只剩裸墙等待下一轮创作。",
                "清除修复：修复了旧引用导致清除后旧涂料仍残留的 Bug。三个 canvas 图层现在真正被全部清空。",
            ],
            ja: [
                "3Dスポット解禁：壁がついに三次元になりました。完全なテクスチャのレンガ壁にタグを打てます — 本物のコンクリート、本物のバイブ。",
                "ズームプリセット1/2/3：1を押すと超クローズアップ（100%）、2でミッドディスタンス（58%）、3で全体把握（25%）。2Dと同じホットキーで統一されたフロー。",
                "スクロールズーム：マウスホイールとトラックパッドのピンチはそのまま使えます。ズームバーとパーセントボタンは常にカメラ位置と同期。",
                "3Dパンモード：スペースキーを押し続けるとカーソルがグラブハンドに変わります — 2Dと同じ。ストロークを失わずに壁を移動。",
                "クラウド保存（Ctrl+S）：2Dと3Dの両方で機能するようになりました。Ctrl+Sを押せばピースが直接サーバーへ。作品を失うことはもうありません。",
                "ハードリセット（R）：確認されたワイプは全レイヤーを破壊 — ローカルとクラウドの両方。次のセッションのために裸の壁だけが残ります。",
                "クリア修正：古い参照バグを修正。3つのキャンバスレイヤーが本当にすべて消去されるようになりました。",
            ],
            hi: [
                "3D स्पॉट अनलॉक: पूरी दीवार अब त्रि-आयामी हो गई है। अब आप पूरी बनावट वाली ईंट की दीवार पर बम बना सकते हैं — असली कंक्रीट, असली वाइब।",
                "ज़ूम प्रीसेट 1/2/3: 1 दबाएं क्लोज़ टैग के लिए (100%), 2 मध्य दूरी के लिए (58%), 3 पूरे पीस को देखने के लिए (25%)। 2D जैसी ही हॉटकीज़ — एकीकृत फ्लो।",
                "स्क्रॉल ज़ूम: माउस व्हील और ट्रैकपैड पिंच अभी भी स्वतंत्र रूप से काम करते हैं। ज़ूम बार और प्रतिशत बटन हमेशा सिंक्ड रहते हैं।",
                "3D पैन मोड: Space दबाए रखें और कर्सर ग्रैब हैंड में बदल जाता है — 2D जैसा ही। स्ट्रोक खोए बिना दीवार पर नेविगेट करें।",
                "क्लाउड सेव (Ctrl+S): अब 2D और 3D दोनों में काम करता है। Ctrl+S दबाएं और आपका पीस सीधे सर्वर पर जाता है।",
                "हार्ड रिसेट (R): पुष्टि किया गया वाइप अब सभी लेयर नष्ट करता है — लोकल और क्लाउड दोनों। अगले सेशन के लिए बस नंगी दीवार।",
                "क्लियर फिक्स: पुराने संदर्भ बग को ठीक किया जो क्लियर करने के बाद पुरानी पेंट छोड़ता था। तीनों लेयर अब सच में मिट जाती हैं।",
            ],
        }
    },
    {
        version: "1.16.0",
        date: "2026-03-20",
        changes: {
            en: [
                "Universal Access: The shared canvas is now wide open for everyone. Plus, we buffed out some minor bugs to keep the flow smooth."
            ],
            ru: [
                "Доступ для всех: Общая стенка теперь открыта для каждого райтера. До кучи подровняли мелкие косяки, чтобы флоу был идеальным."
            ],
            es: [
                "Acceso para todos: El muro compartido ahora está abierto para toda la banda. Además, pulimos unos bugs menores para que el estilo no pare."
            ],
            pt: [
                "Acesso para geral: O mural compartilhado agora tá liberado pra todo mundo. Aproveitamos pra tirar uns bugs chatos e deixar o fluxo pesado."
            ],
            de: [
                "Action für alle: Die gemeinsame Wall ist jetzt für jeden Rider offen. Kleine Bugs wurden übermalt, damit der Flow unschlagbar bleibt."
            ],
            fr: [
                "Accès pour tous : Le mur partagé est enfin ouvert à tout le monde. On a aussi gommé quelques petits bugs pour un flow impeccable."
            ],
            th: [
                "กำแพงสำหรับทุกคน: ตอนนี้ใครๆ ก็พ่นบนกำแพงสาธารณะได้แล้ว แถมยังเก็บกวาดบั๊กเล็กๆ น้อยๆ ให้ลื่นไหลยิ่งขึ้น"
            ],
            ko: [
                "전원 패스: 이제 누구나 공유 벽에 태깅할 수 있습니다. 자잘한 버그들도 싹 닦아내서 흐름이 아주 매끄럽습니다."
            ],
            zh: [
                "全员开刷：公共墙面现在对所有人开放。顺便修补了些小毛病，让你的涂鸦手感更上一层楼。"
            ],
            ja: [
                "全員参加OK：共有キャンバスが誰でも描けるようになりました。ついでに細かい不具合も塗りつぶして、フローは完璧です。"
            ],
            hi: [
                "सबके लिए खुला: साझा कैनवास अब हर किसी के लिए खुल गया है। साथ ही, हमने छोटे-मोटे बग्स को भी ठीक कर दिया है।"
            ]
        }
    },
    {
        version: "1.15.12",
        date: "2026-03-17",
        changes: {
            en: [
                "Paint Confirmation: Added a unified bubble-style popup to confirm your first stroke. Now you won't waste paint by accident.",
                "Glassmorphism UI: The confirmation popup now uses a sleek glass effect in the sidebar, matching the test-drive design.",
                "Fullscreen Refinement: In full screen, the confirmation bar is now centered at the bottom with a 32px offset for maximum visibility.",
                "Unified Bar: One single logic for both multi-color picking and single-color painting confirmation. Clean and simple."
            ],
            ru: [
                "Подтверждение рисования: Добавили единый формат баббл-окна для первого штриха. Теперь ты точно не потратишь краску зря.",
                "Glassmorphism UI: Окно подтверждения в сайдбаре теперь использует эффект матового стекла, как и в режиме тест-драйва.",
                "Фуллскрин-тюнинг: В полноэкранном режиме панель подтверждения центрируется внизу с отступом 32px для максимального удобства.",
                "Единый бар: Одна логика и для выбора нескольких цветов, и для подтверждения одного. Всё чётко и понятно."
            ]
        }
    },
    {
        version: "1.15.11",
        date: "2026-03-14",
        changes: {
            en: [
                "Wall Birth: Seven concrete panels, one infinite canvas. Your spray can is finally ready for the public.",
                "Full Screen by Default: The wall is yours. No distractions, just follow your flow.",
                "Pan/Spray Toggle: Use the '/' hotkey or the UI button to slide along the wall, then hit it immediately."
            ],
            ru: [
                "Рождение Стены: Семь бетонных плит, один бесконечный холст. Твоя банка наконец-то дождалась выхода в свет.",
                "Фуллскрин по дефолту: Стена только твоя. Никакого хлама, только твой флоу.",
                "Grab/Spray: Жми '/' или по кнопке, чтобы двигаться вдоль стены и моментально врываться во фристайл."
            ]
        }
    },
    {
        version: "1.15.10",
        date: "2026-03-12",
        changes: {
            en: [
                "Tablet Flow: Pumped up the UI for tablets. Now everything hits the screen exactly where it should, no more hidden bars.",
                "Full Screen Mode: Hit the '\\' key or the toggle to go massive. We hid the footer and sidebar so you can focus on the wall.",
                "Floating Stash: In full screen, you get a premium floating bar. Check your color, switch caps, and zoom in/out in one tap.",
                "Grab/Spray Toggle: Use the '/' hotkey to switch instantly between drawing and panning.",
                "Quick Exit: Jump out of full screen via the menu or the same hotkey '\\'. Draw without boundaries, like a real king.",
                "Touch Polish: Smoothed out the small glitches on touch screens. The flow is now undisputed."
            ],
            ru: [
                "Планшетный вайб: раскачали интерфейс для планшетов. Теперь всё чётко влетает в экраны, никаких уходящих за край баров.",
                "Полноэкранный режим: жамкай '\\' или переключатель, чтобы уйти в полный рост. Спрятали футер и панельки — только ты и стена.",
                "Плавающий стейш: в полноэкранном режиме появилась люксовая плашка. Цвет, пресеты и зум — всё под рукой в один клик.",
                "Grab/Spray: жми '/' чтобы быстро переключиться между рисованием и перемещением. Твое флоу теперь быстрее пули.",
                "Быстрый выход: вылетай из фуллскрина через меню или тот же хоткей '\\'. Рисуй во всю ширь, как настоящий король.",
                "Тач-полировка: подравняли мелкие косяки на тач-экранах. Теперь флоу — просто песня."
            ],
            es: [
                "Flujo Tablet: Mejoramos la UI para tablets. Ahora todo encaja perfecto en pantalla, sin barras rebeldes.",
                "Modo Pantalla Completa: Pulsa '/' o el interruptor para ir a lo grande. Ocultamos el footer y sidebar para que te centres en el muro.",
                "Barra Flotante: En pantalla completa tienes una barra flotante pro. Color, caps y zoom a un solo toque.",
                "Salida Rápida: Sal del modo completo por el menú o el mismo hotkey. Pinta sin límites, como un rey.",
                "Pulido Táctil: Corregimos pequeños fallos en pantallas táctiles. El flujo es indiscutible."
            ],
            pt: [
                "Fluxo Tablet: Melhoramos a UI para tablets. Agora tudo encaixa perfeito na tela, sem barras sumindo.",
                "Modo Tela Cheia: Aperte '/' ou o botão para ficar gigante. Escondemos o rodapé e a lateral para você focar no muro.",
                "Barra Flutuante: Na tela cheia você tem uma barra flutuante pro. Cor, caps e zoom em um só toque.",
                "Saída Rápida: Saia do modo cheio pelo menu ou pelo mesmo hotkey. Pinte sem limites, como um rei.",
                "Polimento Tátil: Corrigimos pequenos bugs em telas de toque. O fluxo agora é pesado."
            ],
            de: [
                "Tablet-Flow: UI für Tablets aufgepumpt. Jetzt passt alles perfekt auf den Screen, keine versteckten Balken mehr.",
                "Vollbildmodus: Drück '/' oder den Schalter für maximale Action. Footer und Sidebar sind weg – nur du und die Wand.",
                "Floating-Stash: Im Vollbild gibt's eine schwebende Premium-Leiste. Farbe, Caps und Zoom mit einem Tap.",
                "Schnell-Exit: Raus aus dem Vollbild übers Menü oder denselben Hotkey. Mal ohne Grenzen, wie ein echter King.",
                "Touch-Polish: Kleine Glitches auf Touchscreens glattgebügelt. Der Flow ist jetzt unschlagbar."
            ],
            fr: [
                "Flow Tablette : On a boosté l'UI pour tablettes. Tout rentre pile dans l'écran, fini les barres qui dépassent.",
                "Mode Plein Écran : Tape '/' ou le bouton pour passer en grand large. On a caché le footer et le sidebar pour focus sur le mur.",
                "Stash Flottant : En plein écran, t'as une barre flottante premium. Couleur, caps et zoom accessibles en un tap.",
                "Sortie Rapide : Quitte le plein écran via le menu ou le même raccourci. Peins sans limites, comme un vrai roi.",
                "Finish Tactile : On a gommé les petits défauts sur les écrans tactiles. Le flow est désormais indiscutable."
            ],
            th: [
                "แท็บเล็ตโฟลว์: อัปเกรด UI สำหรับแท็บเล็ต ทุกอย่างเป๊ะบนหน้าจอ ไม่มีแถบเมนูหลุดขอบอีกต่อไป",
                "โหมดเต็มหน้าจอ: กด '/' หรือปุ่มสลับเพื่อขยายให้สุด เราซ่อนฟุตเตอร์และแถบข้างเพื่อให้คุณโฟกัสที่ผนังได้เต็มที่",
                "แถบลอยระดับเทพ: ในโหมดเต็มหน้าจอ คุณจะได้แถบเมนูลอยตัว เช็คสี เปลี่ยนหัวพ่น และซูมได้ในสัมผัสเดียว",
                "ออกอย่างไว: ออกจากโหมดเต็มหน้าจอผ่านเมนูหรือปุ่มลัดเดิม พ่นได้ไร้ขีดจำกัดเหมือนราชาตัวจริง",
                "ปรับแต่งระบบสัมผัส: เก็บรายละเอียดความผิดพลาดบนหน้าจอสัมผัส โฟลว์การทำงานลื่นไหลไม่มีสะดุด"
            ],
            korean: [
                "태블릿 플로우: 태블릿용 UI를 더 키웠습니다. 이제 모든 것이 화면에 딱 맞게 들어오고, 잘리는 바도 없습니다.",
                "전체 화면 모드: '/' 키나 버튼을 눌러 크게 보십시오. 벽에만 집중할 수 있도록 푸터와 사이드바를 숨겼습니다.",
                "플로팅 바: 전체 화면에서 프리미엄 플로팅 바를 제공합니다. 색상, 캡 전환, 줌 조절을 한 번의 탭으로 해결하세요.",
                "빠른 나가기: 메뉴나 같은 단축키로 전체 화면을 나갈 수 있습니다. 진짜 왕처럼 제한 없이 그리세요.",
                "터치 다듬기: 터치 스크린의 작은 오류들을 수정했습니다. 이제 흐름이 완벽합니다."
            ],
            zh: [
                "平板丝滑体验：针对平板全面优化了 UI。现在所有元素都能精准排布，告别错位的侧边栏。",
                "全屏模式：敲击“/”键或开关，进入深度创作。隐藏了页脚和边侧栏，让你全神贯注面对这面墙。",
                "悬浮工具条：全屏状态下配备悬浮式工具栏。颜色预览、笔刷切换、缩放调整，统统一触即达。",
                "快速返回：通过菜单或同一快捷键即可退出全屏。像街头之王一样，在广阔空间肆意涂鸦。",
                "触控磨合：修复了触屏设备上的微小瑕疵。整体手感顺滑无比，无可争议。"
            ],
            ja: [
                "タブレット・フロー：タブレット向けにUIを強化しました。もうバーが画面外にはみ出すことはありません。",
                "全画面モード：'/' キーかスイッチでフルスクリーンへ。壁に集中できるよう、フッターとサイドバーを非表示にしました。",
                "フローティング・バー：全画面ではプレミアムな浮遊バーが登場。色確認、キャップ交換、ズームがワンタップで可能です。",
                "クイック・イグジット：メニューか同じホットキーで全画面を解除。本物のキングのように、境界なく描きましょう。",
                "タッチの磨き上げ：タッチスクリーンの細かな不具合を修正しました。流れはもう完璧です。"
            ],
            hi: [
                "टैबलेट फ्लो: टैबलेट के लिए UI को और बेहतर बनाया गया है। अब सब कुछ स्क्रीन पर एकदम सही बैठता है, कोई बार गायब नहीं होगा।",
                "फुल स्क्रीन मोड: '/' की या बटन दबाकर बड़ा करें। हमने फूटर और साइडबार हटा दिए हैं ताकि आप सिर्फ दीवार पर ध्यान दें।",
                "फ्लोटिंग स्टैश: फुल स्क्रीन में आपको मिलेगा एक प्रीमियम फ्लोटिंग बार। रंग, कैप्स और ज़ूम बस एक टैप की दूरी पर।",
                "त्वरित निकास: मेनू या उसी हॉटकी से फुल स्क्रीन से बाहर आएं। एक असली किंग की तरह बिना सीमाओं के पेंट करें।",
                "टच पॉलिश: टच स्क्रीन की छोटी-मोटी कमियां दूर की गई हैं। अब काम एकदम मक्खन जैसा चलेगा।"
            ]
        }
    },
    {
        version: "1.15.9",
        date: "2026-03-12",
        changes: {
            en: [
                "Master Stash: We moved your pieces from the browser's dusty corner to the pro vault (PocketBase). Now your work is safe even if you clear your phone's memory.",
                "Smooth puzzles: The wall is now logical chunks. It saves faster than a quick throwie and won't crash your device.",
                "Clean ghosting: No more black backgrounds—every piece stays transparent, exactly how you need it for the NFT drop.",
                "Grid memory: If you set up the metric grid once, we keep it locked. It won't disappear when you go back for the second layer.",
                "Real speed: Compressed every slice of the wall into WebP. High quality, zero lag."
            ],
            ru: [
                "Мастер-стейш: перевезли твои куски из пыльного кэша браузера в нормальное хранилище (PocketBase). Теперь твоя работа не пропадет, даже если почистишь память телефона.",
                "Пазл-стайл: стенка теперь бьется на логические чанки. Сохраняется быстрее быстрого флопа и не вешает девайс.",
                "Чистый прозрачняк: забанили черный фон в превью — теперь всё на прозрачном фоне, как и положено для NFT-дропов.",
                "Сетка на замке: если врубил метрическую сетку один раз, она останется с тобой. Больше не слетает при возвращении на спот.",
                "Реальный вес: каждый кусок стены теперь жмется в WebP. Качество — пушка, лагов — ноль."
            ],
            es: [
                "Alijo Maestro: Mudamos tus piezas del rincón polvoriento del navegador a la bóveda pro (PocketBase). Tu trabajo está a salvo aunque limpies la memoria del móvil.",
                "Estilo Puzzle: El muro ahora se divide en trozos lógicos. Se guarda más rápido que un throwie y no bloquea tu equipo.",
                "Transparencia real: Prohibimos el fondo negro — todo se mantiene transparente, justo lo que necesitas para el drop de NFT.",
                "Rejilla bloqueada: Si activas la cuadrícula, se queda fija. No desaparece al volver por el segundo layer.",
                "Peso pluma: Comprimimos cada trozo del muro en WebP. Calidad top, cero lag."
            ],
            pt: [
                "Esconderijo Mestre: Mudamos suas peças do canto empoeirado do navegador para o cofre profissional (PocketBase). Seu trabalho está salvo mesmo se limpar a memória.",
                "Estilo Quebra-cabeça: O muro agora é dividido em pedaços lógicos. Salva mais rápido que um throwie e não trava seu aparelho.",
                "Transparência real: Acabamos com o fundo preto — tudo fica transparente, exatamente como você precisa para o NFT drop.",
                "Grade travada: Se você ligou a grade uma vez, ela fica. Não some quando você volta pro segundo layer.",
                "Peso real: Comprimimos cada fatia do muro em WebP. Qualidade monstra, zero lag."
            ],
            de: [
                "Master-Stash: Wir haben deine Pieces aus der staubigen Browserecke in den Profi-Tresor (PocketBase) verschoben. Deine Arbeit ist sicher, auch wenn du den Speicher löschst.",
                "Puzzle-Style: Die Wand wird jetzt in logische Chunks zerlegt. Speichert schneller als ein schnelles Throwie und bringt dein Gerät nicht zum Absturz.",
                "Clean Ghosting: Kein schwarzer Hintergrund mehr – alles bleibt transparent, genau so, wie du es für den NFT-Drop brauchst.",
                "Gitter-Speicher: Wenn du das metrische Gitter einmal einschaltest, bleibt es fix. Es verschwindet nicht mehr beim zweiten Layer.",
                "Echter Speed: Jedes Stück der Wand in WebP komprimiert. Hohe Qualität, null Verzögerung."
            ],
            fr: [
                "Stash Master : On a déplacé tes œuvres du coin poussiéreux du navigateur vers la planque pro (PocketBase). Ton travail est en sécurité même si tu vides ton tel.",
                "Style Puzzle : Le mur est divisé en morceaux logiques. Ça sauvegarde plus vite qu'un throwie et ça ne fait plus ramer ton matos.",
                "Transparence totale : On a banni le fond noir — tout reste transparent, pile ce qu'il faut pour ton drop NFT.",
                "Grille verrouillée : Si tu actives la grille une fois, elle reste. Elle ne disparaît plus quand tu reviens pour la deuxième couche.",
                "Vitesse réelle : Chaque morceau de mur est compressé en WebP. Qualité au top, zéro lag."
            ],
            th: [
                "คลังเก็บของระดับเซียน: เราย้ายผลงานของคุณจากแคชเบราว์เซอร์ไปไว้ในคลังที่ปลอดภัย (PocketBase) งานของคุณจะไม่หายไปแม้จะล้างเครื่อง",
                "สไตล์จิ๊กซอว์: กำแพงถูกแบ่งเป็นส่วนๆ ช่วยให้บันทึกได้ไวยิ่งกว่าเดิมและไม่ทำให้เครื่องค้าง",
                "โปร่งใสของจริง: ยกเลิกพื้นหลังสีดำ ทุกรอยพ่นจะโปร่งใส พร้อมสำหรับการทำ NFT",
                "ล็อคเส้นตาราง: หากเปิดเส้นตารางไว้ มันจะคงอยู่ตลอดไป ไม่หายไปเมื่อเริ่มพ่นเลเยอร์ที่สอง",
                "ความเร็วที่แท้จริง: บีบอัดทุกส่วนของกำแพงเป็น WebP คุณภาพสูง แต่ไม่มีดีเลย์"
            ],
            korean: [
                "마스터 은신처: 당신의 작품을 브라우저의 구석진 곳에서 전문 금고(PocketBase)로 옮겼습니다. 휴대폰 메모리를 비워도 작품은 안전합니다.",
                "퍼즐 스타일: 벽을 논리적 조각으로 나누었습니다. 퀵 드로잉보다 빠르게 저장되며 기기에 무리를 주지 않습니다.",
                "투명한 보관: 검은색 배경을 없앴습니다. NFT 드롭에 딱 맞게 모든 조각이 투명하게 유지됩니다.",
                "그리드 고정: 눈금 그리드를 한 번 켜두면 그대로 유지됩니다. 두 번째 레이어를 그릴 때 다시 켤 필요가 없습니다.",
                "진짜 속도: 모든 벽 조각을 WebP로 압축했습니다. 고화질이면서 랙은 전혀 없습니다."
            ],
            zh: [
                "大师保险库：我们将你的作品从旧浏览器角落迁至专业保险库（PocketBase）。即使清理手机内存，你的心血也不会丢失。",
                "拼图架构：墙面现在划分为逻辑分块，保存速度比画个泡泡字还快，且不会让设备卡顿。",
                "极致透明：彻底告别黑底——所有内容保持透明，完美适配 NFT 铸造需求。",
                "网格锁定：只要开启一次米制网格，它就会为你锁定，下次继续创作时无需重复开启。",
                "极速加载：采用 WebP 压缩每一个墙面分片。画质无损，操作零延迟。"
            ],
            ja: [
                "マスター隠し場所：あなたの作品をブラウザのキャッシュからプロ用金庫（PocketBase）へ移しました。スマホのメモリを整理しても作品は安全です。",
                "パズルスタイル：壁を論理的なチャンクに分割しました。スローアップを書くより早く保存され、デバイスも重くなりません。",
                "クリーンな透明感：黒い背景を廃止しました。NFTドロップに最適な透明な状態で全てのピースが保持されます。",
                "グリッド記憶：グリッドを一度オンにすれば固定されます。二層目を描きに戻った時に消えることはありません。",
                "リアルスピード：壁の全スライスをWebPで圧縮。高画質で遅延ゼロです。"
            ],
            hi: [
                "मास्टर स्टैश: हमने आपके पीसेस को ब्राउज़र के कोने से निकालकर सुरक्षित तिजोरी (PocketBase) में रख दिया है। अब फोन फ्री करने पर भी काम गायब नहीं होगा।",
                "पहेली स्टाइल: दीवार को अब टुकड़ों में बांटा गया है। यह थ्रोई से भी तेज सेव होता है और डिवाइस पर बोझ नहीं डालता।",
                "असली पारदर्शिता: काला बैकग्राउंड हटा दिया गया है - सब कुछ पारदर्शी रहता है, जैसा कि NFT ड्रॉप के लिए चाहिए।",
                "ग्रिड लॉक: अगर आप ग्रिड चालू करते हैं, तो वह सेट रहता है। दोबारा आने पर यह गायब नहीं होगा।",
                "असली रफ़्तार: दीवार के हर टुकड़े को WebP में बदला गया। शानदार क्वालिटी, ज़ीरो लैग।"
            ]
        }
    },
    {
        version: "1.15.8",
        date: "2026-03-11",
        changes: {
            en: [
                "Blackbook limit: You can now keep your 10 most recent pieces safe. Older sketches get buffed to save space.",
                "Real moves only: We stopped saving empty tags. Now it only hits the wall when you actually press the cap.",
                "Clean strikes: Fixed double-spraying issues when finishing a piece.",
                "Time Travel (Ctrl+Z): Now you can undo your mistakes by pulling previous versions directly from the cloud."
            ],
            ru: [
                "Лимит блэкбука: теперь мы храним 10 твоих последних кусков. Старые наброски закрашиваются, чтобы не занимать место.",
                "Только реальные движения: перестали сохранять пустые тэги. Краска ложится на стену только когда реально жмешь на кэп.",
                "Чистые линии: убраны двойные срабатывания банки при завершении рисунка.",
                "Назад во времени (Ctrl+Z): теперь можно отменять косяки, доставая прошлые версии куска прямо из облака."
            ],
            es: [
                "Límite de Blackbook: Ahora guardamos tus últimos 10 grafitis. Los bocetos viejos se borran para ahorrar espacio.",
                "Solo movimientos reales: Dejamos de guardar tags vacíos. La pintura solo toca la pared cuando presionas de verdad el cap.",
                "Trazos limpios: Se eliminó el doble disparo de la lata al terminar una pieza.",
                "Viaje en el tiempo (Ctrl+Z): Ahora puedes deshacer tus errores recuperando versiones anteriores directamente de la nube."
            ],
            pt: [
                "Limite do Blackbook: Agora guardamos suas últimas 10 peças. Rascunhos antigos são apagados para economizar espaço.",
                "Apenas movimentos reais: Paramos de salvar tags vazias. A tinta só mancha quando você realmente pressiona o cap.",
                "Traços limpos: Resolvido o problema de spray duplo ao finalizar um desenho.",
                "Viagem no tempo (Ctrl+Z): Agora você pode desfazer seus erros baixando versões antigas direto da nuvem."
            ],
            de: [
                "Blackbook-Limit: Die letzten 10 Pieces bleiben sicher. Ältere Skizzen werden übermalt, um Platz zu sparen.",
                "Nur echte Moves: Leere Tags werden nicht mehr gespeichert. Die Farbe trifft nur noch die Wand, wenn das Cap gedrückt wird.",
                "Saubere Linien: Doppeltes Sprühen beim Beenden eines Pieces wurde behoben.",
                "Zeitreise (Strg+Z): Jetzt kannst du Fehler rückgängig machen, indem du frühere Versionen direkt aus der Cloud holst."
            ],
            fr: [
                "Limite du Blackbook : Nous gardons vos 10 dernières œuvres. Les vieux croquis sont recouverts pour faire de la place.",
                "Mouvements réels uniquement : On ne sauvegarde plus les tags vides. La peinture ne touche le mur que quand vous appuyez vraiment.",
                "Lignes propres : Plus de double spray à la fin du dessin.",
                "Voyage dans le temps (Ctrl+Z) : Vous pouvez désormais annuler vos erreurs en récupérant les versions précédentes directement sur le cloud."
            ],
            th: [
                "ขีดจำกัดแบล็กบุ๊ก: ตอนนี้คุณเก็บชิ้นงาน 10 รอยล่าสุดได้แล้ว รอยเก่าจะถูกลบเพื่อเพิ่มพื้นที่ว่าง",
                "บันทึกเฉพาะลายที่พ่นจริง: รอยเคลื่อนที่เปล่าๆ จะไม่ถูกนับอีกต่อไป สเปรย์จะพ่นลงกำแพงเมื่อคุณกดหัวพ่นจริงๆ เท่านั้น",
                "พ่นสะอาด: แก้ไขปัญหาการพ่นสเปรย์ซ้อนเมื่อวาดลวดลายเสร็จ"
            ],
            korean: [
                "블랙북 제한: 최근 10개의 그래피티만 보관합니다. 공간을 위해 가장 오래된 스케치부터 지워집니다.",
                "진짜 태깅만: 빈 태그를 저장하지 않습니다. 캡을 제대로 눌러야만 벽에 페인트가 묻습니다.",
                "깔끔한 마무리: 피스를 마칠 때 두 번 분사되는 현상을 수정했습니다."
            ],
            zh: [
                "黑本限制：现在你最多保留最后10个作品，旧的草图会被抹掉腾出空间。",
                "只保留真实创作：不再保存空挥操作，只有真正按下喷头时涂鸦才会留在墙上。",
                "干净收尾：修复了完成喷绘时的双重喷射问题。"
            ],
            ja: [
                "ブラックブックの制限：最新の10作品を保存できます。古いスケッチはスペース確保のために上書きされます。",
                "リアルな動きのみ：空のタグを保存するのをやめました。実際にキャップを押した時だけ壁にペイントされます。",
                "クリーンなライン：ピース完了時の二重スプレーの不具合を修正しました。"
            ],
            hi: [
                "ब्लैकबुक लिमिट: अब आप अपने नवीनतम 10 पीस सुरक्षित रख सकते हैं। जगह बचाने के लिए पुराने स्केच मिटा दिए जाते हैं।",
                "केवल असली टैगिंग: খালি टैग्स सहेजना बंद। पेंट केवल तभी दीवार को छूता है जब आप वास्तव में कैप दबाते हैं।",
                "साफ लाइनें: पीस खत्म करते समय डबल स्प्रे की समस्या ठीक की गई।"
            ]
        }
    },
    {
        version: "1.15.7",
        date: "2026-03-11",
        changes: {
            en: [
                "Secret stash setup: Your blackbook works stealthier now. Cops won't find it so easily in the neighborhood.",
                "Clean walls: Erased weird paint flashes when approaching the wall.",
                "Smooth flow: Less noise when you unpack your markers and cans."
            ],
            ru: [
                "Скрытые тайники: твой блэкбук теперь работает скрытнее. Инспекторам сложнее найти наши данные на районе.",
                "Чистые стены: закрасили странные мерцания интерфейса при подходе к стенке.",
                "Плавный флоу: теперь меньше шума при распаковке маркеров и банок."
            ],
            es: [
                "Escondite secreto: Tu blackbook es más sigiloso. La policía no lo encontrará tan fácilmente en el barrio.",
                "Paredes limpias: Eliminados los destellos raros de pintura al acercarse al muro.",
                "Flujo suave: Menos ruido al sacar tus latas y marcadores."
            ],
            pt: [
                "Esconderijo secreto: Seu blackbook é mais furtivo agora. A polícia não vai achar tão fácil pelo bairro.",
                "Paredes limpas: Borrões estranhos nas paredes ao chegar foram apagados.",
                "Fluxo suave: Menos barulho ao pegar suas latas e tintas."
            ],
            de: [
                "Verstecktes Stash: Dein Blackbook ist jetzt unsichtbarer. Cops finden es im Viertel nicht mehr so leicht.",
                "Saubere Wände: Komisches Flackern der Wand wurde übermalt.",
                "Smoother Flow: Weniger Rauschen beim Auspacken deiner Dosen."
            ],
            fr: [
                "Cachette secrète : Ton blackbook est plus discret. Les flics le trouveront moins facilement dans le quartier.",
                "Murs propres : Les clignotements bizarres du mur en s'approchant ont été effacés.",
                "Flow fluide : Moins de bruit lors du déballage des bombes."
            ],
            th: [
                "จุดซ่อนความลับ: แบล็กบุ๊กของคุณแนบเนียนยิ่งขึ้น ตำรวจหาไม่เจอหรอก",
                "กำแพงสะอาด: ลบรอยภาพแปลกๆ ตอนเริ่มลงมือกำแพง",
                "ลื่นไหล: ลดเสียงรบกวนเวลาหยิบสีมาพ่น"
            ],
            korean: [
                "비밀 은신처: 당신의 블랙북은 이제 더욱 은밀합니다. 짭새들이 쉽게 정보를 찾지 못할 것입니다.",
                "깨끗한 벽: 벽에 접근할 때 깜박이는 이상한 화면을 덮어버렸습니다.",
                "부드러운 흐름: 스프레이를 꺼낼 때 불필요한 소음을 줄였습니다."
            ],
            zh: [
                "秘密藏匿点：你的黑本现在更隐蔽了，条子很难在街区发现我们的数据。",
                "干净的墙壁：靠近墙面的画面闪烁现在被修复了。",
                "流畅动作：掏出罐子开喷时不再有杂音。"
            ],
            ja: [
                "シークレットな隠し場所：ブラックブックがよりステルスになりました。警察はエリアの情報をすぐには見つけられません。",
                "クリーンな壁：壁に近づくときの奇妙な画面の点滅を塗りつぶしました。",
                "スムーズなフロー：スプレー缶を取り出す際のノイズが減りました。"
            ],
            hi: [
                "सीक्रेट स्टैश सेटअप: आपकी ब्लैकबुक अब गुप्त है। पुलिस को आसानी से डेटा नहीं मिलेगा।",
                "साफ दीवारें: दीवार के पास आने पर अजीब फ्लैश को हटा दिया गया।",
                "सुचारू प्रवाह: डिब्बे निकालते समय कम शोर।"
            ]
        }
    },
    {
        version: "1.15.6",
        date: "2026-03-11",
        changes: {
            en: [
                "Cloud Blackbook: Your colors and fresh pieces are safely locked in a secure stash so you never lose them.",
                "Fixed the flash: Stopped the language menu from blinking weirdly when pulling it from your pocket."
            ],
            ru: [
                "Блэкбук в облаке: твои цвета и свежие куски надежно спрятаны в тайнике на сервере. Больше ничего не пропадет.",
                "Закрасили вспышки: меню языков больше не моргает странно, будто это неисправный фонарь."
            ],
            es: [
                "Blackbook en la nube: Tus colores y nuevas piezas están guardados de forma segura en nuestro alijo.",
                "Adiós destellos: El menú de idioma ya no parpadea de forma extraña al sacarlo del bolsillo."
            ],
            pt: [
                "Blackbook na Nuvem: Suas cores e peças estão seguras em nosso esconderijo.",
                "Fim das piscadas: O menu de idioma não pisca mais de forma estranha ao abri-lo."
            ],
            de: [
                "Cloud-Blackbook: Deine Farben und Pieces sind jetzt sicher im Cloud-Stash verstaut.",
                "Störendes Blinken weg: Das Sprachmenü flackert nicht mehr auf dem Handy."
            ],
            fr: [
                "Blackbook Cloud : Tes couleurs et tes œuvres sont en sécurité dans notre planque.",
                "Fin du clignotement : Le menu des langues ne clignote plus bizarrement sur mobile."
            ],
            th: [
                "แบล็กบุ๊กคลาวด์: สีและผลงานของคุณซ่อนไว้อย่างปลอดภัยบนเซิร์ฟเวอร์",
                "แก้แสงกะพริบ: เมนูภาษาไม่กระพริบแปลกๆ อีกแล้ว"
            ],
            korean: [
                "클라우드 블랙북: 고유 색상과 새로운 작품이 안전한 서버 은신처에 보관되어 절대 잃어버리지 않습니다.",
                "깜박임 수정: 폰 켤 때 언어 메뉴가 번쩍이는 현상을 고쳤습니다."
            ],
            zh: [
                "云端黑本：你的专属颜色与新作品已安全隐藏在云端保护金库，再也不会丢失。",
                "修补闪烁：从口袋里掏出界面时，语言菜单不再怪异闪烁。"
            ],
            ja: [
                "クラウドブラックブック：あなたの色と新しいピースは安全なサーバーのマスター隠し場所に保管され、失われることはありません。",
                "フラッシュ修正：スマホを取り出した時に言語メニューが奇妙に点滅するのを直しました。"
            ],
            hi: [
                "क्लाउड ब्लैकबुक: आपके रंग और नए पीस अब सर्वर पर सुरक्षित हैं।",
                "फ्लैश ठीक किया: फ़ोन पर भाषा मेनू अब अजीब तरह से झपकाता नहीं है।"
            ]
        }
    },
    {
        version: "1.15.0",
        date: "2026-03-07",
        changes: {
            en: [
                "Instant gear pickup: The cans and nozzles are right where you left them last session. No need to switch your setup.",
                "Quick trash button: The 'Reset' option jumps out instantly if you changed your default caps.",
                "Wall proportions: The background size scales perfectly when you step back from the block.",
                "Fresh coat of paint: Eliminated some weird mismatch errors when priming the wall."
            ],
            ru: [
                "Экипа на месте: возвращаешься на спот, а краска и кэпы настроены ровно как в прошлый раз — менять ничего не нужно.",
                "Быстрый сброс: кнопка сброса сразу под рукой, если ты пришел со своими кастомными настройками насадок.",
                "Пропорции стенки: фон ложится идеально ровно, когда отходишь назад осмотреть весь двор.",
                "Свежий грунт: убраны баги несоответствия между чертежом и итоговой стеной."
            ],
            es: [
                "Latas preparadas: La pintura y las boquillas están justo como las dejaste la última vez. Listo para disparar.",
                "Reinicio rápido: El botón de reinicio aparece al instante si llevas tapas personalizadas.",
                "Proporciones del muro: El tamaño de la pared se ajusta como debe al alejarte.",
                "Muro imprimado: Eliminamos errores extraños en las texturas de inicio."
            ],
            pt: [
                "Equipamento no lugar: As latas e os caps estão como você deixou na última sessão. Chegou, pintou.",
                "Reset rápido: O botão de reset aparece na hora se você chegou com caps modificados.",
                "Proporções perfeitas: A parede de fundo se adapta bem quando você dá uns passos para trás.",
                "Tinta fresca: Acabamos com manchas estranhas da pintura inicial."
            ],
            de: [
                "Ausrüstung startklar: Dosen und Caps sind genau so eingestellt, wie du sie verlassen hast. Direkt loslegen.",
                "Schneller Reset: Der Reset-Button ist sofort da, falls du deine Caps ummontiert hast.",
                "Wandmaße stimmen: Der Hintergrund skaliert nahtlos, wenn du vom Block zurücktrittst.",
                "Frische Grundierung: Keine fehlerhaften Textur-Überlappungen mehr beim Wall-Setup."
            ],
            fr: [
                "Équipement prêt : Tes bombes et tes caps sont exactement comme tu les avais laissés. Tu n'as plus qu'à attaquer le mur.",
                "Reset rapide : Le bouton de réinitialisation est dispo direct si tu as trafiqué tes caps.",
                "Proportions correctes : Le mur de fond s'ajuste parfaitement quand tu prends du recul.",
                "Sous-couche appliquée : Finis les bugs graphiques chelous quand on prépare le terrain."
            ],
            th: [
                "หยิบอุปกรณ์ทันใจ: กระป๋องและหัวพ่นสีรอคุณอยู่ที่เดิมจากครั้งก่อน ไม่ต้องมานั่งตั้งค่าใหม่",
                "ปุ่มรีเซ็ตด่วน: หากใช้หัวพ่นสายคัสตอม ปุ่มรีเซ็ตจะโผล่มาทันที",
                "สัดส่วนกำแพง: ขนาดกำแพงเข้าที่เป๊ะๆ เมื่อคุณถอยหลังเพื่อดูผลงานชิ้นโบแดง",
                "สีลงพื้นใหม่: แก้บั๊กกำแพงเลอะเทอะตั้งแต่ก่อนเริ่มพ่น"
            ],
            korean: [
                "세팅 유지: 스프레이와 노즐이 어제 남겨둔 상태 그대로입니다. 다시 조작할 필요가 없습니다.",
                "빠른 공장초기화: 개조 캡을 들고 오면 '초기화' 버튼이 바로 뜹니다.",
                "벽 비율: 블록에서 뒤로 물러났을 때 뒷배경이 완벽하게 맞춰집니다.",
                "프라이머 페인트: 처음에 벽이 이상하게 칠해지는 버그를 닦아냈습니다."
            ],
            zh: [
                "装备留档：罐子和喷头保持着你上次收工时的状态，无需重新调整即可开喷。",
                "快速找回手感：如果检测到你私下改了喷头，“重置”按钮会快速弹出来。",
                "完美墙面比例：当你退后几步观察时，背景会完美匹配街区尺寸。",
                "初次打底完美：清除了开场背景初始化时墙面涂料对不上的怪现象。"
            ],
            ja: [
                "セッティング維持：前回作業を終えた時のスプレー缶とノズルの状態がそのまま維持されています。すぐにペイントを開始できます。",
                "素早いリセット：カスタムキャップを取り付けている場合、リセットボタンがすぐに表示されます。",
                "壁の比率：ブロックから離れて全体を見る時、背景のサイズが完璧に調整されます。",
                "プライマー塗装：壁の初回準備時の不一致バグを綺麗に取り除きました。"
            ],
            hi: [
                "गियर तुरंत तैयार: डिब्बे और नोजल वहीं हैं जहां आपने छोड़े थे। फिर से सेट करने की जरूरत नहीं।",
                "त्वरित रीसेट: अगर आपने कस्टम नोजल लगा रखा है तो रीसेट बटन तुरंत आ जाता है।",
                "दीवार का अनुपात: जब आप दीवार से पीछे हटते हैं तो पृष्ठभूमि पूरी तरह फिट बैठती है।",
                "प्राइमर लेप: शुरुआती गड़बड़ियों को ठीक किया गया।"
            ]
        }
    },
    {
        version: "1.14.1",
        date: "2026-03-06",
        changes: {
            en: [
                "Polished the surface: smoothed out a couple of rough edges and bugs.",
                "Test run safe: you can swap caps on a piece without messing up your active color.",
                "Reset memory: trashing the test-run won't reset your pocket's top can.",
                "Bolder marks: the currently picked tone shows 20% clearer so you never grab the wrong fat cap."
            ],
            ru: [
                "Полировочка: зашкурили мелкие баги в интерфейсе и сгладили углы.",
                "Безопасная распрыска: теперь можно тестить ширину фат-кэпа на картоне, не сбивая основной выбранный цвет банки.",
                "Память красок: сброс тест-драйва не забудет цвет банки, что у тебя в руках.",
                "Жирный акцент: индикатор активного цвета стал на 20% крупнее, чтобы не перепутать хром с белым в сумерках."
            ]
        }
    },
    {
        version: "1.14.0",
        date: "2026-03-06",
        changes: {
            en: [
                "Shortcut map: hid a quick look-up key combo cheatsheet down below for fast steez.",
                "Key styles: the key previews look like actual mechanical caps now.",
                "No accidental wiping: added street rules to stop the browser from sweeping away your work with trackpad gestures.",
                "Cleaner tags: hit 'R' twice back-to-back to buff the whole wall in a flash.",
                "Escape route: hitting 'Esc' properly blasts away any annoying pop-up menus blocking your vision."
            ],
            ru: [
                "Шпаргалка финтов: спрятали в футере карту всех горячих клавиш для стритовых комбинаций.",
                "Реальный стиль кнопок: теперь кнопки в справке выглядят как реальные механические колпачки.",
                "Без случайных баффов: ввели правило улицы, блокирующее браузерный свайп двумя пальцами (чтобы случайно не стереть кусок).",
                "Мгновенный бафф: двойное нажатие 'R' теперь моментально очищает всю стенку для новой работы.",
                "План побега: кнопка 'Esc' быстро разгоняет любую мешающую менюху или модалку перед глазами."
            ]
        }
    },
    {
        version: "1.13.0",
        date: "2026-03-01",
        changes: {
            en: [
                "Flat caps allowed: every nozzle variant (Big, Mid, Small) now has a Flat mode for sharper tags. Just double-tap the cap to engage.",
                "Smooth flow: paint spreads nicely even if you swing your arm real fast, no more chunky dots.",
                "Fixed jagged lines: spiral and tight curved throws with the Skinny cap look butter smooth now.",
                "No ghosting: removed thin phantoms of paint showing up between discrete dabs."
            ],
            ru: [
                "Каллиграфия на месте: каждый размер кэпа (Big, Mid, Small) теперь поддерживает Flat-режим для плоского распыла и стильных тэгов. Просто кликни дважды по активному кэпу.",
                "Плавный флоу: краска ложится ровно даже если машешь баллоном со скоростью света. Больше никаких пунктирных кусков.",
                "Сбрил зазубрины: спирали и мелкие скругления на скинни-кэпе теперь гладкие, словно масло.",
                "Никаких фантомов: бафнули невидимые нити краски, летающие между отдельными кликами на стену."
            ]
        }
    },
    {
        version: "1.12.0",
        date: "2026-02-26",
        changes: {
            en: [
                "Mix your own buckets: Set your own personal color ways and name your palette.",
                "Fat pockets: Adding new tones just made your baggy pants hold up to 30 custom cans.",
                "Quick swaps: Tapping an empty spot opens the backpack right to your fresh spray stash for a rapid swap."
            ],
            ru: [
                "Мешай свои цвета: теперь можно собирать собственные палитры, красить район уникальными оттенками и давать им имена.",
                "Широкие карманы: добавление нового цвета автоматически распечатывает сумку до 30 слотов под банки.",
                "Быстрая замена: клик по пустому месту мгновенно открывает бэгпак с цветами для быстрой заливки."
            ]
        }
    }
];
